import * as React from 'react';
// import { Input as MaskedInput } from 'reactstrap';
// import InputMask from 'react-input-mask';
import '../../../css/config.css';
import {
    Button,
    Input,
    Checkbox,
    Form,
    Label,
    Radio,
    Segment,
    Tab,
    Modal,
    Dropdown
} from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    templateName ?: any; mode ?: any; mediaReceiveDurationMode ?: any; mediaReceiveDurationFile ?: any; mediaReceiveDurationTime ?: any;
    derivedVariantStartupTimeEnable ?: boolean; derivedVariantStartupTimeThreshold ?: any; videoStartFailureEnable ?:
    boolean; videoStartFailureThreshold ?: any; dvstRecalcEnable ?: boolean; vsfRecalcEnable ?: boolean;
    videoStartFailureAvailability ?: boolean; dnsTimingMaxTime ?: any; dnsTimingEnable ?: boolean; dnsTimingMaxErrors15Enable ?: boolean;
    dnsTimingMaxErrors15Value ?: any; dnsErrorsMaxErrors15Enable ?: boolean; dnsErrorsMaxErrors15Value ?: any; dnsErrorsWinSize ?: any;
    dnsErrorsWinThresholdEnable ?: boolean; dnsErrorsWinThresholdValue ?: any; dnsErrorsAvailabilty ?: boolean; tcpTimingMaxTime ?: any;
    tcpTimingEnable ?: boolean; tcpTimingMaxErrorsEnable ?: boolean; tcpTimingMaxErrorsValue ?: any; tcpErrorsMaxErrors15Enable ?: boolean;
    tcpErrorsMaxErrors15Value ?: any; tcpErrorsWinSize ?: any; tcpErrorsWinThresholdEnable ?: boolean; tcpErrorsWinThresholdValue ?: any;
    tcpErrorsAvailability ?: boolean; http4MaxEnable ?: boolean; http4MaxValue ?: any; http4WinSize ?: any; http4WinThreshEnable ?: boolean;
    http4WinThreshValue ?: any; http4Exclusions ?: any; http5MaxEnable ?: boolean; http5MaxValue ?: any; http5WinSize ?: any;
    http5WinThreshEnable ?: boolean; http5WinThreshValue ?: any; http5Exclusions ?: any; httpMimeEnable ?: boolean; httpExpressions ?: any;
    playlistStalledEnable ?: boolean; playlistStalledValue ?: any; playlistStalledAvailability ?: boolean; playlistVariantErrorEnable ?: boolean;
    playlistVariantErrorValue ?: any; playlistFileErrorEnable ?: boolean; playlistFileErrorValue ?: any; playlistFileAvailability ?: boolean;
    playlistUnavailableErrorEnable ?: boolean; playlistUnavailableErrorValue ?: any; playlistUnavailableAvailability ?: boolean;
    mediaFilesSeqMaxEnable ?: boolean; mediaFilesSeqMaxValue ?: any; mediaFilesSeqMax15Enable ?: boolean; mediaFilesSeqMax15Value ?: any;
    mediaFilesSeqMaxContEnable ?: boolean; mediaFilesSeqMaxContValue ?: any; mediaFilesSeqAvailability ?: boolean; mediaFilesSeqESPeriod ?: any;
    mediaFilesDurMax15Enable ?: boolean; mediaFilesDurMax15Value ?: any; mediaFilesDurMax ?: any; mediaFilesDurMaxAvailability ?: boolean;
    mediaFilesDurESPeriod ?: any; mediaFilesBRDeviation?: any; mediaFilesBR15Enable ?: boolean; mediaFilesBR15Value ?: any;
    mediaFilesAudioEnable ?: boolean; mediaFilesAudioAvailability ?: boolean; mediaFilesVideoEnable ?: boolean; mediaFilesVideoValue ?: any;
    mediaFilesVideoAvailability ?: boolean; mediaFilesDecryptEnable ?: boolean; mediaFilesDecryptAvailability ?: boolean;
    mediaFilesOutThreshold ?: any; mediaFilesOutAvailability ?: boolean; mediaFilesUnavailWinSize ?: any; mediaFilesUnavailMaxEnable ?: boolean;
    mediaFilesUnavailMaxValue ?: any; mediaFilesUnavailMaxAvailability ?: boolean; veristreamThreshold ?: any; veristreamMaxEP ?: any;
    veristreamMaxED ?: any; veristreamMaxEPEnable ?: boolean; veristreamMaxEP15Enable ?: boolean; veristreamMaxEP15Value ?: any;
    veristreamMaxEDEnable ?: boolean; veristreamBufferThreshEnable ?: boolean; veristreamBufferThreshValue ?: any;
    veristreamBufferMax15Enable ?: boolean; veristreamBufferMax15Value ?: any; veristreamBufferWinSize ?: any;
    veristreamBufferWinThreshEnable ?: boolean; veristreamBufferWinThreshValue ?: any; veristreamBufferAvailability ?: boolean;
    subtitleCaptionThreshold ?: any; subtitleCaptionWinSize ?: any; subtitleCaptionWinMaxEnable ?: boolean; subtitleCaptionWinMaxValue ?: any;
    subtitleFormatWinSize ?: any; subtitleFormatWinMaxEnable ?: boolean; subtitleFormatWinMaxValue ?: any;
    subtitleStalledThreshEnable ?: any; subtitleStalledThreshValue ?: any; playlistVariantsRequiredEnable?: boolean; playlistVariantsRequiredExpr?: any;
    showModal ?: boolean; showValidateModal?: boolean; showErrorModal?: boolean; errorMessage?: any; mosAudioThreshEnable ?: boolean; mosAudioThreshValue ?: any; mosAudioDurError ?: any; mosAudioAvailDurError ?: any;
    mosVideoThreshEnable ?: boolean; mosVideoThreshValue ?: any; mosVideoDurError ?: any; mosVideoAvailDurError ?: any;
    blacknessThreshEnable ?: boolean; blacknessThreshValue ?: any; blacknessDurError ?: any; blacknessAvailDurError ?: any;
    stillnessThreshEnable ?: boolean; stillnessThreshValue ?: any; stillnessDurError ?: any; stillnessAvailDurError ?: any;
    mosAudioAvailEnable?: boolean; mosVideoAvailEnable?: boolean; blacknessAvailEnable?: boolean; stillnessAvailEnable?: boolean;
    audioLoudnessMinEnable?: boolean; audioLoudnessMinValue?: any; audioLoudnessMinDuration?: any; audioLoudnessMaxEnable?: boolean; audioLoudnessMaxValue?: any; audioLoudnessMaxDuration?: any;
    dialnormDevEnable?: boolean; targetLoudnessValue?: any; dialnormDevValue?: any; dialnormDevDuration?: any; dialnormDevAvailEnable?: boolean; dialnormDevAvailValue?: any;
    silenceAlarmEnable?: boolean; silenceDetectMode?: any; silenceChannels?: any; silenceAlarmDuration?: any;
    audioFL?: boolean; audioFC?: boolean; audioFR?: boolean; audioRL?: boolean; audioRR?: boolean; audioLFE?: boolean;
    variants?: any; testExpression?: any; qoeLicensePresent: boolean; spliceAlarmEnable ?: boolean; schedules ?: any; DAILicensePresent: boolean;
    spliceOutDur?: any; underThresholdEnable?: boolean; underThresholdValue?: any; underDuration?: any; overThresholdEnable?: boolean; overThresholdValue?: any; overDuration?: any;
    formatMismatchEnable?: boolean; formatDurError?: any; manifestMode?: boolean; fileMode?: boolean; videoCodecChar?: boolean; videoResChar?: boolean; audioSampChar?: boolean;
    showGuideModal?: boolean; mediaDuration?: number; mediaBuffer?: number; badMediaThreshold?: number; goodMediaThreshold?: number; mediaBufferOption?: boolean;
    badMediaThresholdTmp?: number; goodMediaThresholdTmp?: number;
    veristreamBufferThreshEnableTmp?: boolean; veristreamBufferThreshValueTmp?: number; veristreamBufferWinThreshEnableTmp?: boolean; veristreamBufferWinThreshValueTmp?: number;
    veristreamBufferWinSizeTmp?: number; veristreamBufferMax15EnableTmp?: boolean; veristreamBufferMax15ValueTmp?: number;
    spliceSeqAlarmEnable?: boolean; spliceSeqAlarmDurError?: number; spliceSeqAlarmInNoOutMode?: boolean; spliceSeqAlarmOutNoInMode?: boolean;
    dlTimeMaxEnable?: boolean; dlTimeMaxValue?: any; dlTimeDevValue?: any; dlTimeWinSize?: any;
    mfDurMinEnable?: boolean; mfDurMinValue?: any; mfDurMinDuration?: any;
    mfTimingAlignEnable?: boolean; mfTimingAlignDur?: number; mfTimingAlignMode?: number; mfTimingAlignVideo?: boolean; mfTimingAlignAudio?: boolean; mfTimingAlignTol?: number;
    audioSilenceError?: boolean; blacknessErrors?: boolean; dialNormDevError?: boolean; maxAudioLoudnessErrors?: boolean; minAudioLoudnessErrors?: boolean; mosAudioError?: boolean;
    mosVideoErrors?: boolean; stillnessErrors?: boolean; mediaTimeEnable?: boolean; mediaTimeDevMin?: number; mediaTimeDevMax?: number; mediaTimeDevModalOpen?: boolean;
    vsfAlarmDuration?: number; dvstAlarmDuration?: number; VODOnlyLicensePresent: boolean; idrFrameStartEnable: boolean; idrFrameStartValue: number; idrFrameStartWinSize: number;
    pixelAnalysisThresholdValue: number; pixelAnalysisThresholdEnable: boolean; pixelAnalysisDurationError: number; pixelAnalysisVODThumbnailArchive: boolean;
    gopMosVideoThreshEnable ?: boolean; gopMosVideoThreshValue ?: any; gopMosVideoDurError ?: any; gopMosVideoAvailEnable ?: boolean; mosGopError ?: boolean;
}
interface Props {
    mode: string;
    templateName: string;
    refresh: any;
    allTemplates: any;
}

export default class AlarmTemplateConfig extends React.Component<Props, State> {

    private statusOptions = [ { value: 'Video', text: 'Video' }, { value: 'Audio', text: 'Audio'}, { value: 'Caption', text: 'Caption' }];

    private errorLabel = 'Errors Maximum';
    private modeDependentLabel = 'Maximum';
    private eventMaxLabel = 'Events Maximum';
    private fifteenMinute = '';

    clearData() {
        this.setState({
            templateName: '', mode: 'any', mediaReceiveDurationMode: '', mediaReceiveDurationFile: '', mediaReceiveDurationTime: '',
            derivedVariantStartupTimeEnable: false, derivedVariantStartupTimeThreshold: '', videoStartFailureEnable: false,
            videoStartFailureThreshold: '', videoStartFailureAvailability: false, dvstRecalcEnable: false, vsfRecalcEnable: false,
            dnsTimingMaxTime : '', dnsTimingEnable: false, dnsTimingMaxErrors15Enable: false, dnsTimingMaxErrors15Value: '',
            dnsErrorsMaxErrors15Enable: false, dnsErrorsMaxErrors15Value: '', dnsErrorsWinSize: '', dnsErrorsWinThresholdEnable: false,
            dnsErrorsWinThresholdValue: '', dnsErrorsAvailabilty: false,
            tcpTimingMaxTime: '', tcpTimingEnable: false, tcpTimingMaxErrorsEnable: false, tcpTimingMaxErrorsValue: '',
            tcpErrorsMaxErrors15Enable: false, tcpErrorsMaxErrors15Value: '', tcpErrorsWinSize: '', tcpErrorsWinThresholdEnable: false,
            tcpErrorsWinThresholdValue: '', tcpErrorsAvailability: false,
            http4MaxEnable: false, http4MaxValue: '', http4WinSize: '', http4WinThreshEnable: false, http4WinThreshValue: '',
            http4Exclusions: '', http5MaxEnable: false, http5MaxValue: '', http5WinSize: '', http5WinThreshEnable: false,
            http5WinThreshValue: '', http5Exclusions: '', httpMimeEnable: false, httpExpressions: '',
            playlistStalledEnable: false, playlistStalledValue: '', playlistStalledAvailability: false, playlistVariantErrorEnable: false,
            playlistVariantErrorValue: '', playlistFileErrorEnable: false, playlistFileErrorValue: '', playlistFileAvailability: false,
            playlistUnavailableErrorEnable : false, playlistUnavailableErrorValue: '', playlistUnavailableAvailability: false,
            mediaFilesSeqMaxEnable: false, mediaFilesSeqMaxValue: '', mediaFilesSeqMax15Enable: false, mediaFilesSeqMax15Value: '',
            mediaFilesSeqMaxContEnable: false, mediaFilesSeqMaxContValue: '', mediaFilesSeqAvailability: false, mediaFilesSeqESPeriod: '',
            mediaFilesDurMax15Enable: false, mediaFilesDurMax15Value: '', mediaFilesDurMax: '', mediaFilesDurMaxAvailability: false,
            mediaFilesDurESPeriod: '', mediaFilesBRDeviation: '', mediaFilesBR15Enable: false, mediaFilesBR15Value: '',
            mediaFilesAudioEnable: false, mediaFilesAudioAvailability: false, mediaFilesVideoEnable: false, mediaFilesVideoValue: '',
            mediaFilesVideoAvailability: false, mediaFilesDecryptEnable: false, mediaFilesDecryptAvailability: false,
            mediaFilesOutAvailability: false, mediaFilesOutThreshold: '', mediaFilesUnavailWinSize: '', mediaFilesUnavailMaxEnable: false,
            mediaFilesUnavailMaxValue: '', mediaFilesUnavailMaxAvailability: false, veristreamThreshold: '', veristreamMaxEP: '',
            veristreamMaxED: '', veristreamMaxEPEnable: false, veristreamMaxEP15Enable: false, veristreamMaxEP15Value: '',
            veristreamMaxEDEnable: false, veristreamBufferThreshEnable: false, veristreamBufferThreshValue: '',
            veristreamBufferMax15Enable: false, veristreamBufferMax15Value: '', veristreamBufferWinSize: '',
            veristreamBufferWinThreshEnable: false, veristreamBufferWinThreshValue : '', veristreamBufferAvailability: false,
            subtitleCaptionThreshold: '', subtitleCaptionWinSize: '', subtitleCaptionWinMaxEnable: false, subtitleCaptionWinMaxValue: '',
            subtitleFormatWinSize: '', subtitleFormatWinMaxEnable: false, subtitleFormatWinMaxValue: '',
            subtitleStalledThreshEnable: false, subtitleStalledThreshValue: '', playlistVariantsRequiredExpr: '',
            playlistVariantsRequiredEnable: false, showModal: false, showValidateModal: false, showErrorModal: false, errorMessage: '', mosAudioThreshEnable: false,
            mosAudioThreshValue: '', mosAudioDurError: '', mosAudioAvailDurError: '',  mosVideoThreshEnable: false,
            mosVideoThreshValue: '', mosVideoDurError: '', mosVideoAvailDurError: '', blacknessThreshEnable: false,
            blacknessThreshValue: '', blacknessDurError: '', blacknessAvailDurError: '',
            stillnessThreshEnable: false, stillnessThreshValue: '', stillnessDurError: '', stillnessAvailDurError: '',
            mosAudioAvailEnable: false, mosVideoAvailEnable: false, blacknessAvailEnable: false, stillnessAvailEnable: false,
            audioLoudnessMinEnable: false, audioLoudnessMinValue: '', audioLoudnessMinDuration: '', audioLoudnessMaxEnable: false, audioLoudnessMaxValue: '', audioLoudnessMaxDuration: '',
            dialnormDevEnable: false, targetLoudnessValue: '', dialnormDevValue: '', dialnormDevDuration: '', dialnormDevAvailEnable: false, dialnormDevAvailValue: '',
            silenceAlarmEnable: false, silenceDetectMode: '', silenceChannels: '', silenceAlarmDuration: '',
            audioFL: false, audioFC: false, audioFR: false, audioRL: false, audioRR: false, audioLFE: false,
            variants: [], testExpression: '', qoeLicensePresent: false, spliceAlarmEnable: false, schedules: [], DAILicensePresent: false,
            spliceOutDur: '', underThresholdEnable: false, underThresholdValue: '', underDuration: '', overThresholdEnable: false, overThresholdValue: '', overDuration: '',
            formatMismatchEnable: false, formatDurError: '', manifestMode: false, fileMode: false, videoCodecChar: false, videoResChar: false, audioSampChar: false,
            showGuideModal: false,  mediaDuration: 10, mediaBuffer: 60, badMediaThreshold: 99, goodMediaThreshold: 100, mediaBufferOption: false,
            badMediaThresholdTmp: 99, goodMediaThresholdTmp: 100,
            veristreamBufferThreshEnableTmp: false, veristreamBufferThreshValueTmp: 0, veristreamBufferWinThreshEnableTmp: false, veristreamBufferWinThreshValueTmp: 0,
            veristreamBufferWinSizeTmp: 0, veristreamBufferMax15EnableTmp: false, veristreamBufferMax15ValueTmp: 0,
            spliceSeqAlarmEnable: false, spliceSeqAlarmDurError: 0, spliceSeqAlarmInNoOutMode: false, spliceSeqAlarmOutNoInMode: false,
            dlTimeMaxEnable: false, dlTimeMaxValue: '', dlTimeDevValue: '', dlTimeWinSize: '',
            mfDurMinEnable: false, mfDurMinValue: '', mfDurMinDuration: '',
            mfTimingAlignEnable:  false, mfTimingAlignDur: 0, mfTimingAlignMode: 0, mfTimingAlignVideo: false, mfTimingAlignAudio: false, mfTimingAlignTol: 0,
            audioSilenceError: false, blacknessErrors: false, dialNormDevError: false, maxAudioLoudnessErrors: false, minAudioLoudnessErrors: false, mosAudioError: false,
            mosVideoErrors: false, stillnessErrors: false, mediaTimeEnable: false, mediaTimeDevMin: 0, mediaTimeDevMax: 0, mediaTimeDevModalOpen: false, vsfAlarmDuration: 0,
            dvstAlarmDuration: 0, VODOnlyLicensePresent: false, idrFrameStartEnable: false, idrFrameStartValue: 0, idrFrameStartWinSize: 0, pixelAnalysisThresholdValue: 0,
            pixelAnalysisThresholdEnable: false, pixelAnalysisDurationError: 0, pixelAnalysisVODThumbnailArchive: false,
            gopMosVideoThreshEnable: false, gopMosVideoThreshValue: '', gopMosVideoDurError: '', gopMosVideoAvailEnable: false, mosGopError: false
        });
    }
    componentWillMount() {

        if (this.props.mode === 'All Segments' || this.props.mode === 'Header Only') {
            this.errorLabel = '15-Minute Errors Maximum';
            this.modeDependentLabel = '15-Minute Maximum';
            this.eventMaxLabel = '15-Minute Events Maximum';
            this.fifteenMinute = '-15M';
        }
        this.clearData();

        this.renderDVSConfig = this.renderDVSConfig.bind(this);
        this.renderDNSConfig = this.renderDNSConfig.bind(this);
        this.renderTCPConfig = this.renderTCPConfig.bind(this);
        this.renderHTTPConfig = this.renderHTTPConfig.bind(this);
        this.renderManifestConfig = this.renderManifestConfig.bind(this);
        this.renderMediaFilesConfig = this.renderMediaFilesConfig.bind(this);
        this.renderVSConfig = this.renderVSConfig.bind(this);
        this.renderTextFileConfig = this.renderTextFileConfig.bind(this);
        this.renderQoEConfig = this.renderQoEConfig.bind(this);
        this.renderDAIConfig = this.renderDAIConfig.bind(this);
        this.update = this.update.bind(this);
        this.handleWarningClose = this.handleWarningClose.bind(this);
        this.validateVariants = this.validateVariants.bind(this);
        this.handleValidateModalClose = this.handleValidateModalClose.bind(this);
        this.handleErrorModalClose = this.handleErrorModalClose.bind(this);
        this.handleGuideModalClose = this.handleGuideModalClose.bind(this);
        this.setVSValues = this.setVSValues.bind(this);
        this.fetchData();
    }

    componentDidMount(): void {
        let oauth;

        if (window.sessionStorage && (oauth = window.sessionStorage.getItem('oauth'))) {
            let result = JSON.parse(oauth);
            if (result.QoELicensePresent) {
                this.setState({qoeLicensePresent: true});
            } else {
                this.setState({qoeLicensePresent: false});
            }
            if (result.DAILicensePresent) {
                this.setState({DAILicensePresent: true});
            } else {
                this.setState({DAILicensePresent: false});
            }
            if (result.VODOnlyLicensePresent) {
                this.setState({VODOnlyLicensePresent: true});
            } else {
                this.setState({VODOnlyLicensePresent: false});
            }
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.templateName !== this.props.templateName) {
            if (this.props.templateName === 'Add New Template') {
                this.fetchData('new');
            } else {
                this.fetchData();
            }
        }

        if (this.props.mode === 'All Segments' || this.props.mode === 'Header Only' || this.props.mode === 'Dynamic Ad') {
            this.errorLabel = '15-Minute Errors Maximum';
            this.modeDependentLabel = '15-Minute Maximum';
            this.eventMaxLabel = '15-Minute Events Maximum';
            this.fifteenMinute = '-15M';
        } else {
            // Changed for VOD only, SAN-4251
            if (this.props.mode === 'VOD') {
                this.modeDependentLabel = 'Enable';
            } else {
                this.modeDependentLabel = 'Maximum';
            }
            this.errorLabel = 'Errors Maximum';
            this.eventMaxLabel = 'Events Maximum';
            this.fifteenMinute = '';
        }
    }

    renderDVSConfig() {
        return (
            <div>
                {this.props.mode !== 'Dynamic Ad' &&
                <React.Fragment>
                    <Segment.Group className="system-config-segment">
                        <Segment className="segment-header">Video Startup</Segment>
                        <Segment>
                            <Form>
                                <Form.Group grouped>
                                    <Label className="segment-section-header-300">
                                        Video Start Failure
                                    </Label>
                                    <Label className="right-align-label-width250">
                                        Threshold (secs)
                                    </Label>
                                    <Input
                                        className="small-input-leftMargin"
                                        value={this.state.videoStartFailureThreshold}
                                        maxLength={8}
                                        onChange={(e: any, data: any) => this.setState({videoStartFailureThreshold: data.value})}
                                    />
                                    <Label className="segment-config-description">
                                        VSF-TIME
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label-width550">
                                        Enable Alarm
                                    </Label>
                                    <Checkbox
                                        className="config-checkbox"
                                        checked={this.state.videoStartFailureEnable}
                                        onChange={(e: any, data: any) => this.setState({videoStartFailureEnable: data.checked})}
                                    />
                                    <Label className="segment-config-description">
                                        VSF-TIME-EXCEED
                                    </Label>
                                </Form.Group>
                                {this.props.mode !== 'VOD' &&
                                <Form.Group grouped>
                                    <Label className="right-align-label-width550">
                                        Asset Availability
                                    </Label>
                                    <Checkbox
                                        className="config-checkbox"
                                        checked={this.state.videoStartFailureAvailability}
                                        onChange={(e: any, data: any) => this.setState({videoStartFailureAvailability: data.checked})}
                                    />
                                    <Label className="segment-config-description">
                                        VSF-AA
                                    </Label>
                                </Form.Group>}
                                <Form.Group grouped>
                                    <Label className="right-align-label-width550">
                                        Recalculate (every 15 minutes) Enable
                                    </Label>
                                    <Checkbox
                                        className="config-checkbox"
                                        checked={this.state.vsfRecalcEnable}
                                        onChange={(e: any, data: any) => this.setState({vsfRecalcEnable: data.checked})}
                                    />
                                    <Label className="segment-config-description">
                                        VSF-TIME-RECALC
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label-width550">
                                        Alarm Duration (minutes)
                                    </Label>
                                    <Input
                                        className="small-input-leftMargin"
                                        value={this.state.vsfAlarmDuration}
                                        maxLength={16}
                                        onChange={(e: any, data: any) => this.setState({vsfAlarmDuration: data.value})}
                                    />
                                    <Label className="segment-config-description">
                                        VSF-ALARM-DUR
                                    </Label>
                                </Form.Group>
                            </Form>
                        </Segment>
                        {this.props.mode !== 'Header Only' &&
                        <React.Fragment>
                            <Segment>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="segment-section-header-300">
                                            Derived Variant Startup Time
                                        </Label>
                                        <fieldset id="fieldSet1" className="field-set">
                                            <legend>Media Threshold</legend>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width520">
                                                    File Count
                                                </Label>
                                                <Radio
                                                    name="radioGroup"
                                                    value={0}
                                                    checked={this.state.mediaReceiveDurationMode === 0}
                                                    onChange={(e: any, data: any) => this.setState({ mediaReceiveDurationMode: data.value})}
                                                />
                                                <Input
                                                    disabled={this.state.mediaReceiveDurationMode !== 0}
                                                    className="small-input-radio-leftMargin"
                                                    maxLength={8}
                                                    value={this.state.mediaReceiveDurationFile}
                                                    onChange={(e: any, data: any) => this.setState({mediaReceiveDurationFile: data.value})}
                                                />
                                                <Label className="segment-config-description">
                                                    DVST-MR-FILE
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width522">
                                                    Time (secs)
                                                </Label>
                                                <Radio
                                                    name="radioGroup"
                                                    value={1}
                                                    checked={this.state.mediaReceiveDurationMode === 1}
                                                    onChange={(e: any, data: any) => this.setState({ mediaReceiveDurationMode: parseInt(data.value, 10)})}
                                                />
                                                <Input
                                                    disabled={this.state.mediaReceiveDurationMode !== 1}
                                                    className="small-input-radio-leftMargin"
                                                    maxLength={8}
                                                    value={this.state.mediaReceiveDurationTime}
                                                    onChange={(e: any, data: any) => this.setState({mediaReceiveDurationTime: data.value})}
                                                />
                                                <Label className="segment-config-description">
                                                    DVST-MR-TIME
                                                </Label>
                                            </Form.Group>
                                        </fieldset>
                                        <div className="spacerFS"/>
                                        <Label className="right-align-label-width550">
                                            Maximum Time to Reach Media Threshold (secs)
                                        </Label>
                                        <Input
                                            className="small-input-leftMargin"
                                            value={this.state.derivedVariantStartupTimeThreshold}
                                            maxLength={8}
                                            onChange={(e: any, data: any) => this.setState({derivedVariantStartupTimeThreshold: data.value})}
                                        />
                                        <Label className="segment-config-description">
                                            DVST-TIME
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-width550">
                                            Enable Alarm
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.derivedVariantStartupTimeEnable}
                                            onChange={(e: any, data: any) => this.setState({derivedVariantStartupTimeEnable: data.checked})}
                                        />
                                        <Label className="segment-config-description">
                                            DVST-TIME-EXCEED
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-width550">
                                            Recalculate (every 15 minutes) Enable
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.dvstRecalcEnable}
                                            onChange={(e: any, data: any) => this.setState({dvstRecalcEnable: data.checked})}
                                        />
                                        <Label className="segment-config-description">
                                            DVST-TIME-RECALC
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-width550">
                                            Alarm Duration (minutes)
                                        </Label>
                                        <Input
                                            className="small-input-leftMargin"
                                            value={this.state.dvstAlarmDuration}
                                            maxLength={16}
                                            onChange={(e: any, data: any) => this.setState({dvstAlarmDuration: data.value})}
                                        />
                                        <Label className="segment-config-description">
                                            DVST-ALARM-DUR
                                        </Label>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </React.Fragment>
                        }
                    </Segment.Group>
                </React.Fragment>
            }

            {this.props.mode === 'Dynamic Ad' &&
            <Segment.Group className="system-config-segment">
                <Segment className="segment-header">Video Startup alarms are not valid for {this.props.mode} mode</Segment>
            </Segment.Group>
            }</div>
        );
    }

    renderDNSConfig() {
        return (
            <Segment.Group className="system-config-segment">
                <Segment className="segment-header">DNS</Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                DNS Time Errors
                            </Label>
                            <Label className="right-align-label-width250">
                                Threshold (milliseconds)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.dnsTimingMaxTime}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({dnsTimingMaxTime: data.value})}
                            />
                            <Label className="segment-config-description">
                                DNS-TIME-THR
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Enable Alarm
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.dnsTimingEnable}
                                onChange={(e: any, data: any) => this.setState({dnsTimingEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                DNS-TIME-EXCEED
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                {this.errorLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.dnsTimingMaxErrors15Enable}
                                onChange={(e: any, data: any) => this.setState({dnsTimingMaxErrors15Enable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.dnsTimingMaxErrors15Enable}
                                className="small-input-radio-leftMargin"
                                maxLength={8}
                                value={this.state.dnsTimingMaxErrors15Value}
                                onChange={(e: any, data: any) => this.setState({dnsTimingMaxErrors15Value: data.value})}
                            />
                            <Label className="segment-config-description">
                                DNS-TIME-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                DNS Errors
                            </Label>
                            <Label className="right-align-label-width250">
                                {this.errorLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.dnsErrorsMaxErrors15Enable}
                                onChange={(e: any, data: any) => this.setState({dnsErrorsMaxErrors15Enable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.dnsErrorsMaxErrors15Enable}
                                className="small-input-radio-leftMargin"
                                maxLength={8}
                                value={this.state.dnsErrorsMaxErrors15Value}
                                onChange={(e: any, data: any) => this.setState({dnsErrorsMaxErrors15Value: data.value})}
                            />
                            <Label className="segment-config-description">
                                DNS-FAIL-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Sliding Alarm Window Size (minutes)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.dnsErrorsWinSize}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({dnsErrorsWinSize: data.value})}
                            />
                            <Label className="segment-config-description">
                                DNS-FAIL-WIN
                            </Label>
                        </Form.Group>}
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Window Errors Maximum
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.dnsErrorsWinThresholdEnable}
                                onChange={(e: any, data: any) => this.setState({dnsErrorsWinThresholdEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.dnsErrorsWinThresholdEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.dnsErrorsWinThresholdValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({dnsErrorsWinThresholdValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                DNS-FAIL-COUNT-WIN
                            </Label>
                        </Form.Group>
                         }
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.dnsErrorsAvailabilty}
                                onChange={(e: any, data: any) => this.setState({dnsErrorsAvailabilty: data.checked})}
                            />
                            <Label className="segment-config-description">
                                DNS-FAIL-AA
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>
            </Segment.Group>
        );
    }

    renderTCPConfig() {
        return (
            <Segment.Group className="system-config-segment">
                <Segment className="segment-header">TCP</Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Connection Time Errors
                            </Label>
                            <Label className="right-align-label-width250">
                                Threshold (milliseconds)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.tcpTimingMaxTime}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({tcpTimingMaxTime: data.value})}
                            />
                            <Label className="segment-config-description">
                                CONN-TIME-THR
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Enable Alarm
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.tcpTimingEnable}
                                onChange={(e: any, data: any) => this.setState({tcpTimingEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                CONN-TIME-EXCEED
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                {this.errorLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.tcpTimingMaxErrorsEnable}
                                onChange={(e: any, data: any) => this.setState({tcpTimingMaxErrorsEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.tcpTimingMaxErrorsEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.tcpTimingMaxErrorsValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({tcpTimingMaxErrorsValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                CONN-TIME-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Connection Errors
                            </Label>
                            <Label className="right-align-label-width250">
                                {this.errorLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.tcpErrorsMaxErrors15Enable}
                                onChange={(e: any, data: any) => this.setState({tcpErrorsMaxErrors15Enable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.tcpErrorsMaxErrors15Enable}
                                className="small-input-radio-leftMargin"
                                value={this.state.tcpErrorsMaxErrors15Value}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({tcpErrorsMaxErrors15Value: data.value})}
                            />
                            <Label className="segment-config-description">
                                CONN-FAIL-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Sliding Alarm Window Size (minutes)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.tcpErrorsWinSize}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({tcpErrorsWinSize: data.value})}
                            />
                            <Label className="segment-config-description">
                                CONN-FAIL-WIN
                            </Label>
                        </Form.Group>}
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Window Errors Maximum
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.tcpErrorsWinThresholdEnable}
                                onChange={(e: any, data: any) => this.setState({tcpErrorsWinThresholdEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.tcpErrorsWinThresholdEnable}
                                className="small-input-radio-leftMargin"
                                maxLength={8}
                                value={this.state.tcpErrorsWinThresholdValue}
                                onChange={(e: any, data: any) => this.setState({tcpErrorsWinThresholdValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                CONN-FAIL-COUNT-WIN
                            </Label>
                        </Form.Group>}
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.tcpErrorsAvailability}
                                onChange={(e: any, data: any) => this.setState({tcpErrorsAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                CONN-FAIL-AA
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>
            </Segment.Group>
        );
    }

    renderHTTPConfig() {
        return (
            <Segment.Group className="system-config-segment">
                <Segment className="segment-header">HTTP</Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                4xx Errors
                            </Label>
                            <Label className="right-align-label-width250">
                                {this.errorLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.http4MaxEnable}
                                onChange={(e: any, data: any) => this.setState({http4MaxEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.http4MaxEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.http4MaxValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({http4MaxValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                HTTP4-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Sliding Alarm Window Size (minutes)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.http4WinSize}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({http4WinSize: data.value})}
                            />
                            <Label className="segment-config-description">
                                HTTP4-WIN
                            </Label>
                        </Form.Group>
                        }
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Window Errors Maximum
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.http4WinThreshEnable}
                                onChange={(e: any, data: any) => this.setState({http4WinThreshEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.http4WinThreshEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.http4WinThreshValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({http4WinThreshValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                HTTP4-COUNT-WIN
                            </Label>
                        </Form.Group>
                        }
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Status Code Exclusions
                            </Label>
                            <Input
                                className="input-width-230"
                                value={this.state.http4Exclusions}
                                maxLength={15}
                                onChange={(e: any, data: any) => this.setState({http4Exclusions: data.value})}
                            />
                        </Form.Group>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                5xx Errors
                            </Label>
                            <Label className="right-align-label-width250">
                                {this.errorLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.http5MaxEnable}
                                onChange={(e: any, data: any) => this.setState({http5MaxEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.http5MaxEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.http5MaxValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({http5MaxValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                HTTP5-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Sliding Alarm Window Size (minutes)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.http5WinSize}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({http5WinSize: data.value})}
                            />
                            <Label className="segment-config-description">
                                HTTP5-WIN
                            </Label>
                        </Form.Group>
                        }
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Window Errors Maximum
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.http5WinThreshEnable}
                                onChange={(e: any, data: any) => this.setState({http5WinThreshEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.http5WinThreshEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.http5WinThreshValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({http5WinThreshValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                HTTP5-COUNT-WIN
                            </Label>
                        </Form.Group>
                        }
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Status Code Exclusions
                            </Label>
                            <Input
                                className="input-width-230"
                                value={this.state.http5Exclusions}
                                maxLength={15}
                                onChange={(e: any, data: any) => this.setState({http5Exclusions: data.value})}
                            />
                        </Form.Group>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                MIME Header
                            </Label>
                            <Label className="right-align-label-width250">
                                MIME Header Response Fields
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.httpMimeEnable}
                                onChange={(e: any, data: any) => this.setState({httpMimeEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                HTTP-MIME
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Header Field Expression
                            </Label>
                            <Input
                                className="input-width-230"
                                value={this.state.httpExpressions}
                                maxLength={255}
                                onChange={(e: any, data: any) => this.setState({httpExpressions: data.value})}
                            />
                        </Form.Group>
                    </Form>
                </Segment>
            </Segment.Group>
        );
    }
    // Variant Type
    handleTypeDataChange (event: any, index: any) {
        let variants = [...this.state.variants];
        if (event.target.innerText === 'Audio' || event.target.innerText === 'Caption' || event.target.innerText === 'Video' ) {
            variants[index].type = event.target.innerText;
        }

        this.setState({variants});
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Variant BW
    handleBWDataChange (event: any, index: any) {
        let variants = [...this.state.variants];

        variants[index].bw = event.target.value;

        this.setState({variants});
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Variant Tolerance
    handleToleranceDataChange (event: any, index: any) {
        let variants = [...this.state.variants];

        variants[index].tol = event.target.value;

        this.setState({variants});
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Variant Language
    handleLanguageDataChange (event: any, index: any) {
        let variants = [...this.state.variants];

        variants[index].lang = event.target.value;

        this.setState({variants});
        // this.setState({variants}, () => console.log(this.state.variants));
    }
    // Add Default entry for Video variant
    addVariant(index: any) {
        this.setState((prevState) => ({
            variants: [...prevState.variants, {id: index + 1, type: 'Video', bw: ''}],
        }));
    }
    // Remove all variants
    removeVariants() {
        let variants: never[] = [];
        this.setState({variants});
    }
    // Remove current variant
    removeVariant(index: any) {
        // const variants = this.state.variants.filter((x: any, i: any) => i !== index);
        let variants = [...this.state.variants]; // make a separate copy of the array
        variants.splice(index, 1);
        this.setState({variants});
    }
    // extract the parts of the required variants expression for display/edit purposes
    extractVariantsRequired() {
        // *** Test Cases ***
        // 1a. Full expression with Video, Audio and Caption portions: 12 variants
        // let expression = 'video=[{bw=M,2.1M;tol=5};{bw=1.591M};],audio=[{bw=64K;lang=eng,spa};{bw=32K};{lang=eng};{lang=fra};{lang=spa}],caption=[{lang=eng,fra,spa}]'.replace(/],/g, '?');
        // 1b. Video & Audio options: 7 variants
        // let expression = 'video=[{bw=M,2.1M;tol=5};{bw=1.591M};],audio=[{bw=64K;lang=eng,spa};{bw=32K};{lang=eng}]'.replace(/],/g, '?');
        // 1c. Video * Caption options: 6 variants
        // let expression = 'video=[{bw=M,2.1M;tol=5};{bw=1.591M};],caption=[{lang=eng,fra,spa}]'.replace(/],/g, '?');
        // 1d. Audio & Caption: 7 variants
        // let expression = 'audio=[{bw=64K;lang=eng,spa};{bw=32K};{lang=eng}],caption=[{lang=eng,fra,spa}]'.replace(/],/g, '?');
        // 2. video: multiple bw values, no tolerance defined: 3 variants
        // let expression = 'video=[{bw=M,2.1M;tol=5};{bw=1.591M};]'.replace(/],/g, '?');
        // 3. audio: multiple languages, bw, tol & languages specified, bw only, lang only: 6 variants
        // let expression = 'audio=[{bw=64K;lang=eng,spa};{bw=32K;tol=5;lang=eng,fre};{bw=16K};{lang=eng}]'.replace(/],/g, '?');
        // 4. caption: multiple languages specified separately: 3 variants
        // let expression = 'caption=[{lang=eng};{lang=fra};{lang=spa}]'.replace(/],/g, '?');
        // 5. Failed case?
        // let expression = 'video=[{bw=M,2.1M;tol=5};{bw=1.591M};],audio=[{bw=M}],caption=[{lang=eng}]'.replace(/],/g, '?');
        //    transformed = 'video=[{bw=M};{bw=2.1M};{bw=1.591M};]caption=[{lang=eng}]'
        // 6. Forgotten case: Multiple BWs for Audio.
        // *** Original Code ***
        let expression = this.state.playlistVariantsRequiredExpr.replace(/],/g, '?');
        // console.log('***extract: ' + this.state.playlistVariantsRequiredExpr);
        // initialize variants array between template selections
        this.setState((prevState) => ({
            variants: [],
            testExpression: expression
        }));

        let config = expression.split('?');
        for (let i = 0; i < Object.keys(config).length; i++) {
            if (config[i].startsWith('video=[')) {
                if (config[i].search('{')) {
                    for (let j = config[i].indexOf('{'); j >= 0; j = config[i].indexOf('{', j + 1)) {
                        let closingBracket = config[i].indexOf('}', j + 1);

                        // extract video portion of expression
                        let video = config[i].substring(j, closingBracket + 1);

                        let bw = video.indexOf('bw=');
                        // check for tol value
                        let tol = video.indexOf(';');
                        if (tol < 0) {
                            tol = video.indexOf('}');
                        }
                        // extract bw value
                        let bwValue = video.substring(bw + 3, tol);

                        // extract tol value
                        tol = video.indexOf('tol=');
                        let tolValue = 0;
                        if (tol >= 0) {
                            tolValue = parseInt(video.substring(tol + 4, video.indexOf('}')), 10);
                        }

                        // look for multiple bw values in bw value portion
                        let bwValues = bwValue.split(',');

                        // create a separate entry for each bw value
                        for (let k = 0; k < Object.keys(bwValues).length; k++) {
                            // include tol value if present
                            if (tolValue > 0) {
                                this.setState((prevState) => ({
                                    variants: [...prevState.variants, {type: 'Video', bw: bwValues[k], tol: tolValue}],
                                }));
                            } else {
                                this.setState((prevState) => ({
                                    variants: [...prevState.variants, {type: 'Video', bw: bwValues[k], tol: ''}],
                                }));
                            }
                        }
                    }
                }
            } else if (config[i].startsWith('audio=[')) {
                if (config[i].search('{')) {
                    for (let j = config[i].indexOf('{'); j >= 0; j = config[i].indexOf('{', j + 1)) {
                        let closingBracket = config[i].indexOf('}', j + 1);

                        // extract audio configuration
                        let audio = config[i].substring(j, closingBracket + 1);

                        // extract bandwidth
                        let bw = audio.indexOf('bw=');
                        let bwValue = '';
                        let tol = 0;
                        let tolValue = 0;

                        if (bw >= 0) {
                            // check for tol value
                            tol = audio.indexOf(';');
                            if (tol < 0) {
                                tol = audio.indexOf('}');
                            }
                            bwValue = audio.substring(bw + 3, tol);
                        }

                        // extract tolerance
                        tol = audio.indexOf('tol=');
                        if (tol >= 0) {
                            tolValue = parseInt(audio.substring(tol + 4, audio.indexOf('}')), 10);
                        }

                        // extract language configuration
                        let langValue = '';
                        if (audio.indexOf('lang=') >= 0) {
                            for (let k = audio.indexOf('lang='); k >= 0; k = audio.indexOf('lang=', k + 1)) {
                                let lang = audio.indexOf('lang=');
                                langValue += audio.substring(lang + 5, audio.length - 1);
                                langValue += ',';
                            }
                            // strip off the last comma
                            langValue = langValue.substring(0, langValue.length - 1);
                        }

                        // if BW config found
                        if (bwValue !== '') {
                            // look for multiple bw values in bw value portion
                            let bwValues = bwValue.split(',');
                            // create a separate entry for each bw value
                            for (let k = 0; k < Object.keys(bwValues).length; k++) {
                                // if lang config found
                                if (langValue !== '') {
                                    let langValues = langValue.split(',');
                                    for (let l = 0; l < Object.keys(langValues).length; l++) {
                                        if (tolValue > 0) {
                                            this.setState((prevState) => ({
                                                variants: [...prevState.variants, {type: 'Audio', bw: bwValues[k], tol: tolValue, lang: langValues[l]}]
                                            }));
                                        } else if (tolValue === 0) {
                                            this.setState((prevState) => ({
                                                variants: [...prevState.variants, {type: 'Audio', bw: bwValues[k], tol: '', lang: langValues[l]}]
                                            }));
                                        }
                                    }
                                } else {
                                    if (tolValue > 0) {
                                        this.setState((prevState) => ({
                                            variants: [...prevState.variants, {type: 'Audio', bw: bwValues[k], tol: tolValue, lang: ''}]
                                        }));
                                    } else if (tolValue === 0) {
                                        this.setState((prevState) => ({
                                            variants: [...prevState.variants, {type: 'Audio', bw: bwValues[k], tol: '', lang: ''}]
                                        }));
                                    }
                                }
                            }
                        } else {
                            // if lang config found
                            if (langValue !== '') {
                                let langValues = langValue.split(',');
                                for (let l = 0; l < Object.keys(langValues).length; l++) {
                                    if (tolValue > 0) {
                                        this.setState((prevState) => ({
                                            variants: [...prevState.variants, {type: 'Audio', bw: '', tol: tolValue, lang: langValues[l]}]
                                        }));
                                    } else if (tolValue === 0) {
                                        this.setState((prevState) => ({
                                            variants: [...prevState.variants, {type: 'Audio', bw: '', tol: '', lang: langValues[l]}]
                                        }));
                                    }
                                }
                            } else {
                                if (tolValue > 0) {
                                    this.setState((prevState) => ({
                                        variants: [...prevState.variants, {type: 'Audio', bw: '', tol: tolValue, lang: ''}]
                                    }));
                                } else if (tolValue === 0) {
                                    this.setState((prevState) => ({
                                        variants: [...prevState.variants, {type: 'Audio', bw: '', tol: '', lang: ''}]
                                    }));
                                }
                            }
                        }
                    }
                }
            } else if (config[i].startsWith('caption=[')) {
                if (config[i].search('{')) {
                    for (let j = config[i].indexOf('{'); j >= 0; j = config[i].indexOf('{', j + 1)) {
                        let closingBracket = config[i].indexOf('}', j + 1);

                        // extract caption configuration
                        let caption = config[i].substring(j, closingBracket + 1);

                        // extract language configuration
                        let langValue = '';

                        for (let k = caption.indexOf('lang='); k >= 0; k = caption.indexOf('lang=', k + 1)) {
                            let lang = caption.indexOf('lang=');
                            langValue += caption.substring(lang + 5, caption.length - 1);
                            langValue += ',';
                        }

                        // strip off the last comma
                        langValue = langValue.substring(0, langValue.length - 1);

                        let langValues = langValue.split(',');

                        for (let l = 0; l < Object.keys(langValues).length; l++) {
                            this.setState((prevState) => ({
                                variants: [...prevState.variants, {type: 'Caption', lang: langValues[l]}],
                            }));
                        }
                    }
                }
            }
        }
        // console.log(this.state.variants);
    }

    // transform the display back into an expression to be evaluated and saved to the database as a required variants expression.
    transformVariants() {
        let videoOptions = '';
        let audioOptions = '';
        let captionOptions = '';

        // Video data
        for (let i = 0; i < Object.keys(this.state.variants).length; i++) {
            if (this.state.variants[i].type === 'Video') {
                let bw = this.state.variants[i].bw !== undefined && this.state.variants[i].bw !== '' ? 'bw=' + this.state.variants[i].bw : '';
                let tol = this.state.variants[i].tol !== undefined && this.state.variants[i].tol !== '' ? ';tol=' + this.state.variants[i].tol : '';
                videoOptions += '{' + bw + tol + '};';
            }
        }

        // Audio data
        for (let i = 0; i < Object.keys(this.state.variants).length; i++) {
            if (this.state.variants[i].type === 'Audio') {
                let bw = this.state.variants[i].bw !== undefined && this.state.variants[i].bw !== '' ? 'bw=' + this.state.variants[i].bw : '';
                let tol = this.state.variants[i].tol !== undefined && this.state.variants[i].tol !== '' ? ';tol=' + this.state.variants[i].tol : '';
                // tslint:disable-next-line:no-shadowed-variable
                let lang = this.state.variants[i].lang !== undefined && this.state.variants[i].lang !== '' ? ';lang=' + this.state.variants[i].lang : '';
                // BW OR lang is required.
                // Remove semicolon if only lang configured
                if (bw === '' && tol === '') {
                    lang = lang.substring(1, lang.length);
                }
                audioOptions += '{' + bw + tol + lang + '};';
            }
        }

        // Caption data
        let lang = '';
        for (let i = 0; i < Object.keys(this.state.variants).length; i++) {
            if (this.state.variants[i].type === 'Caption') {
                lang = this.state.variants[i].lang !== undefined && this.state.variants[i].lang !== '' ? this.state.variants[i].lang + ',' : '';
                captionOptions += lang;
            }
        }

        // add final formatting
        if (videoOptions !== '') {
            videoOptions = 'video=[' + videoOptions + ']';
            if (audioOptions !== '' || captionOptions !== '') {
                videoOptions = videoOptions + ',';
            }
        }
        if (audioOptions !== '') {
            audioOptions = 'audio=[' + audioOptions.substring(0, audioOptions.length - 1) + ']';
            if (captionOptions !== '') {
                audioOptions = audioOptions + ',';
            }
        }
        if (captionOptions !== '') {
            captionOptions = 'caption=[{lang=' + captionOptions.substring(0, captionOptions.length - 1) + '}]';
        }

        let expression = videoOptions + audioOptions + captionOptions;
        // console.log('***transform: ' + expression);
        this.setState ({playlistVariantsRequiredExpr: expression});
        this.validateVariants(expression);
    }

    renderVariantsRequiredFields() {
        let options = [];
        for (let idx = 0; idx < Object.keys(this.state.variants).length; idx++) {
            let typeId = `type-${idx}`, bwId = `bw-${idx}`, tolId = `tol-${idx}`, langId = `lang-${idx}`;
            options.push((
                    <Form.Group grouped>
                        <Label className="right-align-label-width170" />
                        <Dropdown
                            className="templateDropDown"
                            placeholder="Type"
                            search
                            selection
                            name={typeId}
                            data-id={idx}
                            id={typeId}
                            options={this.statusOptions}
                            value={this.state.variants[idx].type}
                            onChange={(event, data) => this.handleTypeDataChange(event, idx)}
                        />
                        {(this.state.variants[idx].type === 'Video' || this.state.variants[idx].type === 'Audio') ?
                            <React.Fragment>
                                <Label className="variantLabel" >
                                    Bandwidth
                                </Label>
                                <Input
                                    className="variantVideoText"
                                    type="textarea"
                                    placeholder={'e.g. 689200 OR 6.89M'}
                                    name={bwId}
                                    data-id={idx}
                                    id={bwId}
                                    value={this.state.variants[idx].bw}
                                    onChange={(event) => this.handleBWDataChange(event, idx)}
                                />
                            </React.Fragment>  : ' ' }
                        {(this.state.variants[idx].type === 'Video' || this.state.variants[idx].type === 'Audio') ?
                            <React.Fragment>
                                <Label className="variantLabel" >
                                    % Tolerance
                                </Label>
                                <Input
                                    className="variantTolText"
                                    type="number"
                                    placeholder={'default 10%'}
                                    name={tolId}
                                    data-id={idx}
                                    id={tolId}
                                    maxLength="3"
                                    hint="true"
                                    min="1"
                                    max="99"
                                    step="1"
                                    value={this.state.variants[idx].tol}
                                    onChange={(event) => this.handleToleranceDataChange(event, idx)}
                                />
                            </React.Fragment> : ' ' }
                        {(this.state.variants[idx].type === 'Audio' || this.state.variants[idx].type === 'Caption') ?
                            <React.Fragment>
                                <Label className="variantLabel" >
                                    Language
                                </Label>
                                <Input
                                    className="variantLangText"
                                    type="textarea"
                                    placeholder={'e.g. spa'}
                                    name={langId}
                                    data-id={idx}
                                    id={langId}
                                    maxLength={3}
                                    value={this.state.variants[idx].lang}
                                    onChange={(event) => this.handleLanguageDataChange(event, idx)}
                                />
                            </React.Fragment> : ' ' }
                        <Button
                            floated="right"
                            className="rightButton"
                            disabled={Object.keys(this.state.variants).length === 0}
                            content="Remove"
                            title="Remove Variant"
                            onClick={(e, data) => this.removeVariant(idx)}
                        />
                    </Form.Group>
            ));
        }
        return <div>{options}</div>;
    }

    renderManifestConfig() {
        return (
            <Segment.Group className="system-config-segment">
                <Segment className="segment-header">Playlist/Manifest File</Segment>
                {this.props.mode !== 'VOD' && // this.props.mode !== 'Header Only' &&
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Stalled Playlist/Manifest File
                            </Label>
                            <Label className="right-align-label-width250">
                                Alarm Threshold (secs)
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.playlistStalledEnable}
                                onChange={(e: any, data: any) => this.setState({playlistStalledEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.playlistStalledEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.playlistStalledValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({playlistStalledValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                PLAYLIST-STALL
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.playlistStalledAvailability}
                                onChange={(e: any, data: any) => this.setState({playlistStalledAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                PLAYLIST-STALL-AA
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>
                }
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Variant / Profile Count Errors
                            </Label>
                            <Label className="right-align-label-width250">
                                {this.modeDependentLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.playlistVariantErrorEnable}
                                onChange={(e: any, data: any) => this.setState({playlistVariantErrorEnable: data.checked})}
                            />
                            {this.props.mode !== 'VOD' &&
                            <Input
                                disabled={!this.state.playlistVariantErrorEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.playlistVariantErrorValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({playlistVariantErrorValue: data.value})}
                            />}
                            <Label className="segment-config-description">
                                VARIANT-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Playlist File Errors
                            </Label>
                            <Label className="right-align-label-width250">
                                {this.modeDependentLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.playlistFileErrorEnable}
                                onChange={(e: any, data: any) => this.setState({playlistFileErrorEnable: data.checked})}
                            />
                            {this.props.mode !== 'VOD' &&
                            <Input
                                disabled={!this.state.playlistFileErrorEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.playlistFileErrorValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({playlistFileErrorValue: data.value})}
                            />}
                            <Label className="segment-config-description">
                                PLAYLIST-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.playlistFileAvailability}
                                onChange={(e: any, data: any) => this.setState({playlistFileAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                PLAYLIST-COUNT-AA
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>
                {this.props.mode !== 'VOD' &&
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Media Time Deviation<br/>
                                [ Only for MPEG-DASH with segment timeline ]
                                {/*<Modal*/}
                                {/*    closeIcon*/}
                                {/*    onClose={() => this.setState({mediaTimeDevModalOpen: false})}*/}
                                {/*    onOpen={() => this.setState({mediaTimeDevModalOpen: true})}*/}
                                {/*    open={this.state.mediaTimeDevModalOpen}*/}
                                {/*    size="small"*/}
                                {/*    trigger={<Icon name="question circle" size="small" />}*/}
                                {/*>*/}
                                {/*    <Header as="h5" icon className="speedModalHeader">*/}
                                {/*        Media Time Deviation*/}
                                {/*    </Header>*/}
                                {/*    <Modal.Content>*/}
                                {/*        <p>*/}
                                {/*            <b>Note</b>: Applicable to MPEG-DASH segment timeline only.*/}
                                {/*        </p>*/}
                                {/*    </Modal.Content>*/}
                                {/*</Modal>*/}
                            </Label>
                            <Label className="right-align-label-width250">
                                Enable Alarm
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaTimeEnable}
                                onChange={(e: any, data: any) => this.setState({mediaTimeEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                MEDIA-TIME-DEV
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Tolerance (secs)
                            </Label>
                            <Input
                                id="small-input-leftMargin"
                                type="number"
                                maxLength="4"
                                required
                                hint="true"
                                min="-60"
                                max={this.state.mediaTimeDevMax && (this.state.mediaTimeDevMax < 60) ? this.state.mediaTimeDevMax : 60}
                                value={this.state.mediaTimeDevMin}
                                onChange={(e: any, data: any) => this.setState({mediaTimeDevMin: data.value})}
                            />
                            <Label className="left-align-label-35">
                                to
                            </Label>
                            <Input
                                id="small-input-leftMargin"
                                type="number"
                                maxLength="4"
                                required
                                hint="true"
                                min={this.state.mediaTimeDevMin && (this.state.mediaTimeDevMin > -60) ? this.state.mediaTimeDevMin : -60}
                                max="60"
                                value={this.state.mediaTimeDevMax}
                                onChange={(e: any, data: any) => this.setState({mediaTimeDevMax: data.value})}
                            />
                            <Label className="segment-config-description">
                                MEDIA-TIME-DEV-TOL
                            </Label>
                        </Form.Group>
                    </Form>
                </Segment>}
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Playlist / Manifest Unavailable
                            </Label>
                            <Label className="right-align-label-width250">
                                Consecutive Errors Maximum
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.playlistUnavailableErrorEnable}
                                onChange={(e: any, data: any) => this.setState({playlistUnavailableErrorEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.playlistUnavailableErrorEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.playlistUnavailableErrorValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({playlistUnavailableErrorValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                PLAYLIST-UNAVAIL
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.playlistUnavailableAvailability}
                                onChange={(e: any, data: any) => this.setState({playlistUnavailableAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                PLAYLIST-UNAVAIL-AA
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Variants Required
                            </Label>
                            <Label className="right-align-label-width250">
                                Enable Alarm
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.playlistVariantsRequiredEnable}
                                onChange={(e: any, data: any) => this.setState({playlistVariantsRequiredEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                VAR-REQ
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            {/*<Label>*/}
                            {/*    {this.state.testExpression}*/}
                            {/*</Label>*/}
                            {this.renderVariantsRequiredFields()}
                        </Form.Group>
                        <Form.Group>
                            <Button
                                floated="right"
                                className="rightButton"
                                disabled={Object.keys(this.state.variants).length < 64 ? false : true}
                                content="Add"
                                title="Add Variant"
                                onClick={(e, data) => this.addVariant(Object.keys(this.state.variants).length)}
                            />
                            <Button
                                floated="right"
                                className="rightButton"
                                disabled={Object.keys(this.state.variants).length === 0 ? true : false}
                                content="Remove All"
                                title="Remove All Variants"
                                onClick={(e, data) => this.removeVariants()}
                            />
                            {/*<Button*/}
                            {/*    floated="right"*/}
                            {/*    className="rightButton"*/}
                            {/*    disabled={Object.keys(this.state.variants).length < 64 ? false : true}*/}
                            {/*    content={'Total: ' + Object.keys(this.state.variants).length + ': Extract'}*/}
                            {/*    title="Extract Variant"*/}
                            {/*    onClick={(e, data) => this.extractVariantsRequired()}*/}
                            {/*/>*/}
                            {/*<Button*/}
                            {/*    floated="right"*/}
                            {/*    className="rightButton"*/}
                            {/*    disabled={Object.keys(this.state.variants).length < 64 ? false : true}*/}
                            {/*    content="Transform"*/}
                            {/*    title="Transform Variant"*/}
                            {/*    onClick={(e, data) => this.transformVariants()}*/}
                            {/*/>*/}
                            {/*<Button*/}
                            {/*    floated="right"*/}
                            {/*    className="rightButton"*/}
                            {/*    disabled={Object.keys(this.state.variants).length < 64 ? false : true}*/}
                            {/*    content="Validate"*/}
                            {/*    title="Validate Variants"*/}
                            {/*    onClick={(e, data) => this.testValidateVariants()}*/}
                            {/*/>*/}
                            {/*<Label>*/}
                            {/*    {this.state.playlistVariantsRequiredExpr}*/}
                            {/*</Label>*/}
                        </Form.Group>
                    </Form>
                </Segment>
            </Segment.Group>
        );
    }

    renderMediaFilesConfig() {
        return (
            <Segment.Group className="system-config-segment">
                <Segment className="segment-header">Media Files</Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Media File Unavailable
                            </Label>
                            {this.props.mode !== 'VOD' &&
                            <Label className="right-align-label-width250">
                                Alarm Window Size (minutes)
                            </Label>}
                            {this.props.mode !== 'VOD' &&
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.mediaFilesUnavailWinSize}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({mediaFilesUnavailWinSize: data.value})}
                            />}
                            {this.props.mode !== 'VOD' &&
                            <Label className="segment-config-description">
                                MF-UNAVAIL-WIN
                            </Label>}
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Errors Maximum
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesUnavailMaxEnable}
                                onChange={(e: any, data: any) => this.setState({mediaFilesUnavailMaxEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.mediaFilesUnavailMaxEnable}
                                className="small-input-radio-leftMargin"
                                maxLength={8}
                                value={this.state.mediaFilesUnavailMaxValue}
                                onChange={(e: any, data: any) => this.setState({mediaFilesUnavailMaxValue: data.value})}
                            />
                            {this.props.mode !== 'VOD' &&
                            <Label className="segment-config-description">
                                MF-UNAVAIL-COUNT-WIN
                            </Label>
                            }
                            {this.props.mode === 'VOD' &&
                            <Label className="segment-config-description">
                                MF-UNAVAIL-COUNT
                            </Label>
                            }
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesUnavailMaxAvailability}
                                onChange={(e: any, data: any) => this.setState({mediaFilesUnavailMaxAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                MF-UNAVAIL-AA
                            </Label>
                        </Form.Group>
                        }
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Outage
                            </Label>
                            <Label className="right-align-label-width250">
                                Alarm Threshold (secs)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.mediaFilesOutThreshold}
                                maxLength={3}
                                onChange={(e: any, data: any) => this.setState({mediaFilesOutThreshold: data.value})}
                            />
                            <Label className="segment-config-description">
                                OUTAGE
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesOutAvailability}
                                onChange={(e: any, data: any) => this.setState({mediaFilesOutAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                OUTAGE-AA
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>
                {this.props.mode !== 'Header Only' &&
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Download Time Exceeds Media Playback
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Alarm Window Size (minutes)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.dlTimeWinSize}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({dlTimeWinSize: data.value})}
                            />
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Errors Maximum
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.dlTimeMaxEnable}
                                onChange={(e: any, data: any) => this.setState({dlTimeMaxEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.dlTimeMaxEnable}
                                className="small-input-radio-leftMargin"
                                maxLength={8}
                                value={this.state.dlTimeMaxValue}
                                onChange={(e: any, data: any) => this.setState({dlTimeMaxValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                MF-DL-TIME-COUNT-WIN
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Deviation (percent)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                maxLength={8}
                                value={this.state.dlTimeDevValue}
                                onChange={(e: any, data: any) => this.setState({dlTimeDevValue: data.value})}
                            />
                        </Form.Group>
                    </Form>
                </Segment>}
                {this.props.mode !== 'VOD' &&
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Sequence Errors
                            </Label>
                        </Form.Group>
                        {(this.props.mode === 'All Segments' || this.props.mode === 'Header Only' || this.props.mode === 'Dynamic Ad') &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Maximum
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesSeqMaxEnable}
                                onChange={(e: any, data: any) => this.setState({mediaFilesSeqMaxEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.mediaFilesSeqMaxEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.mediaFilesSeqMaxValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({mediaFilesSeqMaxValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                SEQ-ERR-TOT-COUNT
                            </Label>
                        </Form.Group>
                        }
                        {(this.props.mode === 'All Segments' || this.props.mode === 'Header Only' || this.props.mode === 'Dynamic Ad') &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                {this.modeDependentLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesSeqMax15Enable}
                                onChange={(e: any, data: any) => this.setState({mediaFilesSeqMax15Enable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.mediaFilesSeqMax15Enable}
                                className="small-input-radio-leftMargin"
                                value={this.state.mediaFilesSeqMax15Value}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({mediaFilesSeqMax15Value: data.value})}
                            />
                            <Label className="segment-config-description">
                                SEQ-ERR-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                        }
                        {(this.props.mode === 'All Segments' || this.props.mode === 'Header Only' || this.props.mode === 'Dynamic Ad') &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Contiguous Errors Maximum
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesSeqMaxContEnable}
                                onChange={(e: any, data: any) => this.setState({mediaFilesSeqMaxContEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.mediaFilesSeqMaxContEnable}
                                className="small-input-radio-leftMargin"
                                value={this.state.mediaFilesSeqMaxContValue}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({mediaFilesSeqMaxContValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                SEQ-ERR-CONTIG
                            </Label>
                        </Form.Group>
                        }
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesSeqAvailability}
                                onChange={(e: any, data: any) => this.setState({mediaFilesSeqAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                SEQ-ERR-AA
                            </Label>
                        </Form.Group>}
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped className="radio-group-heading">
                            <Label className="right-align-label-width550">
                                ES Period
                            </Label>
                            <Label className="right-align-label-width30"/>
                            <Radio
                                label="One Second"
                                className="radio-group"
                                name="radioGroup1"
                                value={0}
                                checked={this.state.mediaFilesSeqESPeriod === 0}
                                onChange={(e: any, data: any) => this.setState({mediaFilesSeqESPeriod: data.value})}
                            />
                        </Form.Group>}
                        <Form.Group grouped>
                            <Label className="radio-group-label"/>
                            <Radio
                                label="Average File Duration"
                                className="radio-group"
                                name="radioGroup1"
                                value={1}
                                checked={this.state.mediaFilesSeqESPeriod === 1}
                                onChange={(e: any, data: any) => this.setState({mediaFilesSeqESPeriod: data.value})}
                            />
                        </Form.Group>
                    </Form>
                </Segment>}
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Media File Duration
                            </Label>
                            <Label className="right-align-label-width250">
                                Maximum (secs)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.mediaFilesDurMax}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({mediaFilesDurMax: data.value})}
                            />
                            <Label className="segment-config-description">
                                MF-DUR-MAX-THR
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                {this.errorLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesDurMax15Enable}
                                onChange={(e: any, data: any) => this.setState({mediaFilesDurMax15Enable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.mediaFilesDurMax15Enable}
                                className="small-input-radio-leftMargin"
                                value={this.state.mediaFilesDurMax15Value}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({mediaFilesDurMax15Value: data.value})}
                            />
                            <Label className="segment-config-description">
                                MF-DUR-MAX-COUNT{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesDurMaxAvailability}
                                onChange={(e: any, data: any) => this.setState({mediaFilesDurMaxAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                MF-DUR-MAX-AA
                            </Label>
                        </Form.Group>}
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped className="radio-group-heading">
                            <Label className="right-align-label-width550">
                                ES Period
                            </Label>
                            <Label className="right-align-label-width30"/>
                            <Radio
                                className="radio-group"
                                label="One Second"
                                name="radioGroup2"
                                value={0}
                                checked={this.state.mediaFilesDurESPeriod === 0}
                                onChange={(e: any, data: any) => this.setState({mediaFilesDurESPeriod: data.value})}
                            />
                        </Form.Group>}
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="radio-group-label"/>
                            <Radio
                                className="radio-group"
                                label="Average File Duration"
                                name="radioGroup2"
                                value={1}
                                checked={this.state.mediaFilesDurESPeriod === 1}
                                onChange={(e: any, data: any) => this.setState({mediaFilesDurESPeriod: data.value})}
                            />
                        </Form.Group>}
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="radio-group-label"/>
                            <Radio
                                className="radio-group"
                                label="Actual File Duration"
                                name="radioGroup2"
                                value={2}
                                checked={this.state.mediaFilesDurESPeriod === 2}
                                onChange={(e: any, data: any) => this.setState({mediaFilesDurESPeriod: data.value})}
                            />
                        </Form.Group>}
                    </Form>
                </Segment>
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Media File Bit Rate
                            </Label>
                            <Label className="right-align-label-width250">
                                Deviation (percent)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                value={this.state.mediaFilesBRDeviation}
                                maxLength={8}
                                onChange={(e: any, data: any) => this.setState({mediaFilesBRDeviation: data.value})}
                            />
                            <Label className="segment-config-description">
                                MF-BR-DEV
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                {this.errorLabel}
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesBR15Enable}
                                onChange={(e: any, data: any) => this.setState({mediaFilesBR15Enable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.mediaFilesBR15Enable}
                                className="small-input-radio-leftMargin"
                                maxLength={8}
                                value={this.state.mediaFilesBR15Value}
                                onChange={(e: any, data: any) => this.setState({mediaFilesBR15Value: data.value})}
                            />
                            <Label className="segment-config-description">
                                MF-BR-MAX{this.fifteenMinute}
                            </Label>
                        </Form.Group>
                    </Form>
                </Segment>
                {(this.props.mode !== 'Sample' && this.props.mode !== 'Header Only') &&
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Media File Timing Alignment
                            </Label>
                            <Label className="right-align-label-width250">
                                Enable Alarm
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mfTimingAlignEnable}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                MF-TIME-ALIGN
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Alarm Duration (mins)
                            </Label>
                            <Input
                                id="small-input-leftMargin"
                                type="number"
                                maxLength="4"
                                required
                                hint="true"
                                min="1"
                                max="9999"
                                value={this.state.mfTimingAlignDur}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignDur: data.value})}
                            />
                        </Form.Group>}
                        <Form.Group grouped className="radio-group-heading">
                            <Label className="right-align-label-width550">
                                Mode
                            </Label>
                            <Label className="right-align-label-width30"/>
                            <Radio
                                className="radio-group"
                                label="Disable"
                                name="radioGroup2"
                                value={0}
                                checked={this.state.mfTimingAlignMode === 0}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignMode: data.value})}
                            />
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="radio-group-label"/>
                            <Radio
                                className="radio-group"
                                label="All Files"
                                name="radioGroup2"
                                value={1}
                                checked={this.state.mfTimingAlignMode === 1}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignMode: data.value})}
                            />
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="radio-group-label"/>
                            <Radio
                                className="radio-group"
                                label="Media Files Only"
                                name="radioGroup2"
                                value={2}
                                checked={this.state.mfTimingAlignMode === 2}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignMode: data.value})}
                            />
                        </Form.Group>
                        }
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="radio-group-label"/>
                            <Radio
                                className="radio-group"
                                label="Ad Files Only"
                                name="radioGroup2"
                                value={3}
                                checked={this.state.mfTimingAlignMode === 3}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignMode: data.value})}
                            />
                        </Form.Group>
                        }
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="radio-group-label"/>
                            <Radio
                                className="radio-group"
                                label="First Ad File After Splice Out"
                                name="radioGroup2"
                                value={4}
                                checked={this.state.mfTimingAlignMode === 4}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignMode: data.value})}
                            />
                        </Form.Group>
                        }
                        <Form.Group grouped className="radio-group-heading">
                            <Label className="right-align-label-width550">
                                Types
                            </Label>
                            <Label className="right-align-label-width30"/>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mfTimingAlignVideo}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignVideo: data.checked})}
                            />
                            <Label className="right-align-label-width30">
                                Video
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550"/>
                            <Label className="right-align-label-width30"/>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mfTimingAlignAudio}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignAudio: data.checked})}
                            />
                            <Label className="right-align-label-width30">
                                Audio
                            </Label>
                        </Form.Group>
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Time Variance (ticks)
                            </Label>
                            <Input
                                id="small-input-leftMargin"
                                type="number"
                                maxLength="4"
                                required
                                hint="true"
                                min="0"
                                max="9999"
                                value={this.state.mfTimingAlignTol}
                                onChange={(e: any, data: any) => this.setState({mfTimingAlignTol: data.value})}
                            />
                        </Form.Group>
                    </Form>
                </Segment>}
                {this.state.qoeLicensePresent && (this.props.mode !== 'Sample' && this.props.mode !== 'Header Only') &&
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                IDR Frame Detection<br/>
                                [ Content Analysis must be enabled ]
                            </Label>
                            <Label className="right-align-label-width250">
                                Enable Alarm
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.idrFrameStartEnable}
                                onChange={(e: any, data: any) => this.setState({idrFrameStartEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                {this.props.mode !== 'VOD' ? 'MF-IDR-FRAME-COUNT-WIN' : 'MF-IDR-FRAME-COUNT'}
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Sliding Alarm Window Size (minutes)
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                maxLength={8}
                                value={this.state.idrFrameStartWinSize}
                                onChange={(e: any, data: any) => this.setState({idrFrameStartWinSize: data.value})}
                            />
                            <Label className="segment-config-description">
                                MF-IDR-ERR-WIN
                            </Label>
                        </Form.Group>}
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Window Errors Maximum
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                maxLength={8}
                                value={this.state.idrFrameStartValue}
                                onChange={(e: any, data: any) => this.setState({idrFrameStartValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                MF-IDR-ERR-COUNT-WIN
                            </Label>
                        </Form.Group>}
                        {this.props.mode === 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Number of media files without IDR frame before alarm
                            </Label>
                            <Input
                                className="small-input-leftMargin"
                                maxLength={8}
                                value={this.state.idrFrameStartValue}
                                onChange={(e: any, data: any) => this.setState({idrFrameStartValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                MF-IDR-FRAME-COUNT-THR
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>}
                {this.props.mode !== 'Header Only' &&
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Audio Not Present<br/>
                                [ MPEG-2 Only ]
                            </Label>
                            <Label className="right-align-label-width250">
                                Enable Alarm
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesAudioEnable}
                                onChange={(e: any, data: any) => this.setState({mediaFilesAudioEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                NO-AUDIO
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesAudioAvailability}
                                onChange={(e: any, data: any) => this.setState({mediaFilesAudioAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                NO-AUDIO-AA
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>}
                {this.props.mode !== 'Header Only' &&
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Video / Audio Synchronization<br/>
                                [ Smooth Stream Only ]
                            </Label>
                            <Label className="right-align-label-width250">
                                Alarm Threshold (secs)
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesVideoEnable}
                                onChange={(e: any, data: any) => this.setState({mediaFilesVideoEnable: data.checked})}
                            />
                            <Input
                                disabled={!this.state.mediaFilesVideoEnable}
                                className="small-input-radio-leftMargin"
                                maxLength={8}
                                value={this.state.mediaFilesVideoValue}
                                onChange={(e: any, data: any) => this.setState({mediaFilesVideoValue: data.value})}
                            />
                            <Label className="segment-config-description">
                                AV-SYNC
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesVideoAvailability}
                                onChange={(e: any, data: any) => this.setState({mediaFilesVideoAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                AV-SYNC-AA
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>}
                {this.props.mode !== 'Header Only' &&
                <Segment>
                    <Form>
                        <Form.Group grouped>
                            <Label className="segment-section-header-300">
                                Decryption Errors<br/>
                            </Label>
                            <Label className="right-align-label-width250">
                                Enable Alarm
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesDecryptEnable}
                                onChange={(e: any, data: any) => this.setState({mediaFilesDecryptEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                DECRYPT
                            </Label>
                        </Form.Group>
                        {this.props.mode !== 'VOD' &&
                        <Form.Group grouped>
                            <Label className="right-align-label-width550">
                                Asset Availability
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.mediaFilesDecryptAvailability}
                                onChange={(e: any, data: any) => this.setState({mediaFilesDecryptAvailability: data.checked})}
                            />
                            <Label className="segment-config-description">
                                DECRYPT-AA
                            </Label>
                        </Form.Group>}
                    </Form>
                </Segment>}
            </Segment.Group>
        );
    }

    handleClick() {
        this.setState({
          badMediaThresholdTmp: this.state.badMediaThreshold,
          goodMediaThresholdTmp: this.state.goodMediaThreshold,
          veristreamBufferThreshEnableTmp: this.state.veristreamBufferThreshEnable,
          veristreamBufferThreshValueTmp: this.state.veristreamBufferThreshValue,
          veristreamBufferWinThreshEnableTmp: this.state.veristreamBufferWinThreshEnable,
          veristreamBufferWinThreshValueTmp: this.state.veristreamBufferWinThreshValue,
          veristreamBufferWinSizeTmp: this.state.veristreamBufferWinSize,
          veristreamBufferMax15EnableTmp: this.state.veristreamBufferMax15Enable,
          veristreamBufferMax15ValueTmp: this.state.veristreamBufferMax15Value,
          showGuideModal: true
        });
    }

    renderVSConfig() {
         return (
             <div>
            {this.props.mode !== 'Header Only' && this.props.mode !== 'VOD' &&
            <React.Fragment>
                <Segment.Group className="system-config-segment">
                    <Segment className="segment-header">Streaming Performance (based on VeriStream metric)</Segment>
                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Button
                                    floated="right"
                                    className="rightButton"
                                    disabled={false}
                                    content="Guided Configuration"
                                    title="Guided Configuration"
                                    onClick={(e, data) => this.handleClick()}
                                />
                                <Label className="system-config-label veristreamDescription">
                                    Streaming performance measurements and alarm conditions are focused on maintaining a smooth playback experience - avoiding video stuttering, buffering, and quality downshifts. ​
                                </Label>
                                <Label className="system-config-label veristreamDescription">
                                    {/* tslint:disable-next-line:max-line-length */}
                                    Monitoring the streaming experience requires media buffer analysis in the context of ABR video. This is accomplished using per media segment measurements. For each media segment, Telestream uses a 1 (bad) - 5 (good) scoring method for the impact against the cumulative media buffer. This value is called the VeriStream (VS) score. VS provides a measurement of network and system induced packet delay variation (jitter). When used with threshold values that account for media playback duration and the desired media buffer, alerts can be raised for underperforming conditions that model the user experience or predict impending issues.
                                </Label>
                                <Label className="system-config-label veristreamDescription">
                                    {/* tslint:disable-next-line:max-line-length */}
                                    The settings below allow you to model client device behavior based on streaming performance. For help completing the alarm configuration, consider using the Guided Configuration that will automatically take media duration and media buffer into account for alarm thresholds.
                                </Label>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        <Form>
                        <fieldset id="fieldSet1" className="field-set">
                            <legend>VeriStream Configuration</legend>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    Minimum VS Value to Be Considered Bad (1-5)
                                </Label>
                                <Input
                                    className="small-input-leftMargin"
                                    maxLength={8}
                                    value={this.state.veristreamThreshold}
                                    onChange={(e: any, data: any) => this.setState({veristreamThreshold: data.value})}
                                />
                                <Label className="segment-config-description">
                                    VS-THR-ERROR-PERIOD
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    # of Consecutive Bad Segments for ‘Error Period’ Start
                                </Label>
                                <Input
                                    className="small-input-leftMargin"
                                    maxLength={8}
                                    value={this.state.veristreamMaxEP}
                                    onChange={(e: any, data: any) => this.setState({veristreamMaxEP: data.value})}
                                />
                                <Label className="segment-config-description">
                                    VS-EP-MAX-THR
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    # of Consecutive Good Segments to Clear ‘Error Period’
                                </Label>
                                <Input
                                    className="small-input-leftMargin"
                                    maxLength={8}
                                    value={this.state.veristreamMaxED}    // should be minErrorDistance
                                    onChange={(e: any, data: any) => this.setState({veristreamMaxED: data.value})}
                                />
                                <Label className="segment-config-description">
                                    VS-ED-MIN-THR
                                </Label>
                            </Form.Group>
                        </fieldset>
                        </Form>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Label className="segment-section-header-300">
                                    Buffer / Gear Change Risk
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    Duration Alarm
                                </Label>
                                <Checkbox
                                    className="config-checkbox"
                                    checked={this.state.veristreamBufferThreshEnable}
                                    onChange={(e: any, data: any) => this.setState({veristreamBufferThreshEnable: data.checked})}
                                />
                                <Label className="segment-config-description">
                                    BGCR-DUR-EXCEED
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    Duration of Error Period Before Alarm (secs)
                                </Label>
                                <Input
                                    disabled={!this.state.veristreamBufferThreshEnable}
                                    maxLength={8}
                                    className="small-input-leftMargin"
                                    value={this.state.veristreamBufferThreshValue}
                                    onChange={(e: any, data: any) => this.setState({veristreamBufferThreshValue: data.value})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    Sliding Window Event Maximum Alarm
                                </Label>
                                <Checkbox
                                    className="config-checkbox"
                                    checked={this.state.veristreamBufferWinThreshEnable}
                                    onChange={(e: any, data: any) => this.setState({veristreamBufferWinThreshEnable: data.checked})}
                                />
                                <Label className="segment-config-description">
                                    BGCR-WIN
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    Window Size (minutes)
                                </Label>
                                <Input
                                    disabled={!this.state.veristreamBufferWinThreshEnable}
                                    className="small-input-leftMargin"
                                    maxLength={8}
                                    value={this.state.veristreamBufferWinSize}
                                    onChange={(e: any, data: any) => this.setState({veristreamBufferWinSize: data.value})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    Maximum Error Periods in Window Before Alarm
                                </Label>
                                <Input
                                    disabled={!this.state.veristreamBufferWinThreshEnable}
                                    className="small-input-leftMargin"
                                    maxLength={8}
                                    value={this.state.veristreamBufferWinThreshValue}
                                    onChange={(e: any, data: any) => this.setState({veristreamBufferWinThreshValue: data.value})}
                                />
                                <Label className="segment-config-description">
                                    BGCR-COUNT-WIN
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    15-Minute Error Maximum Alarm
                                </Label>
                                <Checkbox
                                    className="config-checkbox"
                                    checked={this.state.veristreamBufferMax15Enable}
                                    onChange={(e: any, data: any) => this.setState({veristreamBufferMax15Enable: data.checked})}
                                />
                                <Label className="segment-config-description">
                                    BGCR-COUNT-15M
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    Maximum Error Periods in 15M Interval Before Alarm
                                </Label>
                                <Input
                                    disabled={!this.state.veristreamBufferMax15Enable}
                                    className="small-input-leftMargin"
                                    maxLength={8}
                                    value={this.state.veristreamBufferMax15Value}
                                    onChange={(e: any, data: any) => this.setState({veristreamBufferMax15Value: data.value})}
                                />
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    Contribute to Asset Availability
                                </Label>
                                <Checkbox
                                    className="config-checkbox"
                                    checked={this.state.veristreamBufferAvailability}
                                    onChange={(e: any, data: any) => this.setState({veristreamBufferAvailability: data.checked})}
                                />
                                <Label className="segment-config-description">
                                    BGCR-AA
                                </Label>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group grouped>
                                <Label className="segment-section-header-300">
                                    Error Period
                                </Label>
                                <Label className="right-align-label-width250">
                                    Error Period Enable Alarm
                                </Label>
                                <Checkbox
                                    className="config-checkbox"
                                    checked={this.state.veristreamMaxEPEnable}
                                    onChange={(e: any, data: any) => this.setState({veristreamMaxEPEnable: data.checked})}
                                />
                                <Label className="segment-config-description">
                                    VS-EP-MAX
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-width550">
                                    {this.eventMaxLabel}
                                </Label>
                                <Checkbox
                                    className="config-checkbox"
                                    checked={this.state.veristreamMaxEP15Enable}
                                    onChange={(e: any, data: any) => this.setState({veristreamMaxEP15Enable: data.checked})}
                                />
                                <Input
                                    disabled={!this.state.veristreamMaxEP15Enable}
                                    maxLength={8}
                                    className="small-input-radio-leftMargin"
                                    value={this.state.veristreamMaxEP15Value}
                                    onChange={(e: any, data: any) => this.setState({veristreamMaxEP15Value: data.value})}
                                />
                                <Label className="segment-config-description">
                                    VS-EPE-COUNT{this.fifteenMinute}
                                </Label>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        <Form>
                            <Label className="right-align-label-width550">
                                Error Distance Enable Alarm
                            </Label>
                            <Checkbox
                                className="config-checkbox"
                                checked={this.state.veristreamMaxEDEnable}
                                onChange={(e: any, data: any) => this.setState({veristreamMaxEDEnable: data.checked})}
                            />
                            <Label className="segment-config-description">
                                VS-ED-MIN
                            </Label>
                        </Form>
                    </Segment>
                </Segment.Group>
            </React.Fragment>
        }
        {(this.props.mode === 'Header Only' || this.props.mode === 'VOD') &&
            <Segment.Group className="system-config-segment">
                <Segment className="segment-header">Streaming Performance alarms are not valid for {this.props.mode} mode</Segment>
            </Segment.Group>
        }</div>
    );
    }

    renderTextFileConfig() {
        return (
            <div>
                {/*<OAuth.Feature Capture>*/}
                    {(this.props.mode === 'All Segments' || this.props.mode === 'Dynamic Ad') &&
                        <React.Fragment>
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">Text (Caption/Subtitle) File</Segment>
                            <Segment>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="segment-section-header-300">
                                            Caption Count
                                        </Label>
                                        <Label className="right-align-label-width250">
                                            Minimum Count Error Threshold
                                        </Label>
                                        <Input
                                            className="small-input-leftMargin"
                                            maxLength={8}
                                            value={this.state.subtitleCaptionThreshold}
                                            onChange={(e: any, data: any) => this.setState({subtitleCaptionThreshold: data.value})}
                                        />
                                        <Label className="segment-config-description">
                                            TEXT-CAP-CNT-MIN-THR
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-width550">
                                            Sliding Alarm Window Size
                                        </Label>
                                        <Input
                                            className="small-input-leftMargin"
                                            maxLength={8}
                                            value={this.state.subtitleCaptionWinSize}
                                            onChange={(e: any, data: any) => this.setState({subtitleCaptionWinSize: data.value})}
                                        />
                                        <Label className="segment-config-description">
                                            TEXT-CAP-CNT-MIN-WIN
                                        </Label>
                                    </Form.Group>
                                    {this.props.mode !== 'Dynamic Ad' &&
                                        <div>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width550">
                                                    Window Errors Maximum
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.subtitleCaptionWinMaxEnable}
                                                    onChange={(e: any, data: any) => this.setState({subtitleCaptionWinMaxEnable: data.checked})}
                                                />
                                                <Input
                                                    disabled={!this.state.subtitleCaptionWinMaxEnable}
                                                    className="small-input-radio-leftMargin"
                                                    maxLength={8}
                                                    value={this.state.subtitleCaptionWinMaxValue}
                                                    onChange={(e: any, data: any) => this.setState({subtitleCaptionWinMaxValue: data.value})}
                                                />
                                                <Label className="segment-config-description">
                                                    TEXT-CAP-CNT-MIN-COUNT-WIN
                                                </Label>
                                            </Form.Group>
                                        </div>}
                                </Form>
                            </Segment>
                            <Segment>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="segment-section-header-300">
                                            Format Errors
                                        </Label>
                                        <Label className="right-align-label-width250">
                                            Sliding Alarm Window Size
                                        </Label>
                                        <Input
                                            className="small-input-leftMargin"
                                            maxLength={8}
                                            value={this.state.subtitleFormatWinSize}
                                            onChange={(e: any, data: any) => this.setState({subtitleFormatWinSize: data.value})}
                                        />
                                        <Label className="segment-config-description">
                                            TEXT-FMT-ERR-WIN
                                        </Label>
                                    </Form.Group>
                                    {this.props.mode !== 'Dynamic Ad' &&
                                    <div>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Window Errors Maximum
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.subtitleFormatWinMaxEnable}
                                                onChange={(e: any, data: any) => this.setState({subtitleFormatWinMaxEnable: data.checked})}
                                            />
                                            <Input
                                                disabled={!this.state.subtitleFormatWinMaxEnable}
                                                className="small-input-radio-leftMargin"
                                                maxLength={8}
                                                value={this.state.subtitleFormatWinMaxValue}
                                                onChange={(e: any, data: any) => this.setState({subtitleFormatWinMaxValue: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                TEXT-FMT-ERR-COUNT-WIN
                                            </Label>
                                        </Form.Group>
                                    </div>}
                                </Form>
                            </Segment>
                            {this.props.mode !== 'Dynamic Ad' &&
                            <Segment>
                                <Form>
                                    <Form.Group grouped>
                                        <Label className="segment-section-header-300">
                                            Stalled Text File
                                        </Label>
                                        <Label className="right-align-label-width250">
                                            Alarm Threshold (secs)
                                        </Label>
                                        <Checkbox
                                            className="config-checkbox"
                                            checked={this.state.subtitleStalledThreshEnable}
                                            onChange={(e: any, data: any) => this.setState({subtitleStalledThreshEnable: data.checked})}
                                        />
                                        <Input
                                            disabled={!this.state.subtitleStalledThreshEnable}
                                            className="small-input-radio-leftMargin"
                                            maxLength={8}
                                            value={this.state.subtitleStalledThreshValue}
                                            onChange={(e: any, data: any) => this.setState({subtitleStalledThreshValue: data.value})}
                                        />
                                        <Label className="segment-config-description">
                                            TEXT-STALL
                                        </Label>
                                    </Form.Group>
                                </Form>
                            </Segment>}
                        </Segment.Group>
                        </React.Fragment>
                    }
                    {(this.props.mode === 'Header Only' || this.props.mode === 'VOD' || this.props.mode === 'Sample') &&
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">
                                {this.props.mode === 'VOD' ? 'Text File alarms are not applicable to video on demand streams.' :
                                    `Text File alarms not valid for ${this.props.mode} mode`}
                            </Segment>
                        </Segment.Group>
                    }
                {/*</OAuth.Feature>*/}
            </div>
        );
    }

    // audioFL?: boolean;  // 0x01  = 1
    // audioFC?: boolean;  // 0x02  = 2
    // audioFR?: boolean;  // 0x04  = 4
    // audioRL?: boolean;  // 0x10  = 16
    // audioRR?: boolean;  // 0x20  = 32
    // audioLFE?: boolean; // 0x100 = 256 (311 total)

    getSilenceChannels(numChannels: any) {
        // console.log('getAudioChannels: silenceChannels: ' + numChannels);
        // tslint:disable-next-line:switch-default
        switch (numChannels) {
            case 0:
                this.setState({
                    silenceChannels: 0,
                    audioFL: false,
                    audioFC: false,
                    audioFR: false,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 1:
                this.setState({
                    silenceChannels: 1,
                    audioFL: true,
                    audioFC: false,
                    audioFR: false,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 2:
                this.setState({
                    silenceChannels: 2,
                    audioFL: false,
                    audioFC: true,
                    audioFR: false,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 3:
                this.setState({
                    silenceChannels: 3,
                    audioFL: true,
                    audioFC: true,
                    audioFR: false,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 4:
                this.setState({
                    silenceChannels: 4,
                    audioFL: false,
                    audioFC: false,
                    audioFR: true,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 5:
                this.setState({
                    silenceChannels: 5,
                    audioFL: true,
                    audioFC: false,
                    audioFR: true,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 6:
                this.setState({
                    silenceChannels: 6,
                    audioFL: false,
                    audioFC: true,
                    audioFR: true,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 7:
                this.setState({
                    silenceChannels: 7,
                    audioFL: true,
                    audioFC: true,
                    audioFR: true,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 16:
                this.setState({
                    silenceChannels: 16,
                    audioFL: false,
                    audioFC: false,
                    audioFR: false,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 17:
                this.setState({
                    silenceChannels: 17,
                    audioFL: true,
                    audioFC: false,
                    audioFR: false,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 18:
                this.setState({
                    silenceChannels: 18,
                    audioFL: false,
                    audioFC: true,
                    audioFR: false,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 19:
                this.setState({
                    silenceChannels: 19,
                    audioFL: true,
                    audioFC: true,
                    audioFR: false,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 20:
                this.setState({
                    silenceChannels: 20,
                    audioFL: false,
                    audioFC: false,
                    audioFR: true,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 21:
                this.setState({
                    silenceChannels: 21,
                    audioFL: true,
                    audioFC: false,
                    audioFR: true,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 22:
                this.setState({
                    silenceChannels: 22,
                    audioFL: false,
                    audioFC: true,
                    audioFR: true,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 23:
                this.setState({
                    silenceChannels: 23,
                    audioFL: true,
                    audioFC: true,
                    audioFR: true,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: false
                });
                break;
            case 32:
                this.setState({
                    silenceChannels: 32,
                    audioFL: false,
                    audioFC: false,
                    audioFR: false,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 33:
                this.setState({
                    silenceChannels: 33,
                    audioFL: true,
                    audioFC: false,
                    audioFR: false,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 34:
                this.setState({
                    silenceChannels: 34,
                    audioFL: false,
                    audioFC: true,
                    audioFR: false,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 35:
                this.setState({
                    silenceChannels: 35,
                    audioFL: true,
                    audioFC: true,
                    audioFR: false,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 36:
                this.setState({
                    silenceChannels: 36,
                    audioFL: false,
                    audioFC: false,
                    audioFR: true,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 37:
                this.setState({
                    silenceChannels: 37,
                    audioFL: true,
                    audioFC: false,
                    audioFR: true,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 38:
                this.setState({
                    silenceChannels: 38,
                    audioFL: false,
                    audioFC: true,
                    audioFR: true,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 39:
                this.setState({
                    silenceChannels: 39,
                    audioFL: true,
                    audioFC: true,
                    audioFR: true,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 48:
                this.setState({
                    silenceChannels: 48,
                    audioFL: false,
                    audioFC: false,
                    audioFR: false,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 49:
                this.setState({
                    silenceChannels: 49,
                    audioFL: true,
                    audioFC: false,
                    audioFR: false,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 50:
                this.setState({
                    silenceChannels: 50,
                    audioFL: false,
                    audioFC: true,
                    audioFR: false,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 51:
                this.setState({
                    silenceChannels: 51,
                    audioFL: true,
                    audioFC: true,
                    audioFR: false,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 52:
                this.setState({
                    silenceChannels: 52,
                    audioFL: false,
                    audioFC: false,
                    audioFR: true,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 53:
                this.setState({
                    silenceChannels: 53,
                    audioFL: true,
                    audioFC: false,
                    audioFR: true,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 54:
                this.setState({
                    silenceChannels: 54,
                    audioFL: false,
                    audioFC: true,
                    audioFR: true,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 55:
                this.setState({
                    silenceChannels: 55,
                    audioFL: true,
                    audioFC: true,
                    audioFR: true,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: false
                });
                break;
            case 256:
                this.setState({
                    silenceChannels: 256,
                    audioFL: false,
                    audioFC: false,
                    audioFR: false,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 257:
                this.setState({
                    silenceChannels: 257,
                    audioFL: true,
                    audioFC: false,
                    audioFR: false,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 258:
                this.setState({
                    silenceChannels: 258,
                    audioFL: false,
                    audioFC: true,
                    audioFR: false,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 259:
                this.setState({
                    silenceChannels: 259,
                    audioFL: true,
                    audioFC: true,
                    audioFR: false,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 260:
                this.setState({
                    silenceChannels: 260,
                    audioFL: false,
                    audioFC: false,
                    audioFR: true,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 261:
                this.setState({
                    silenceChannels: 261,
                    audioFL: true,
                    audioFC: false,
                    audioFR: true,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 262:
                this.setState({
                    silenceChannels: 262,
                    audioFL: false,
                    audioFC: true,
                    audioFR: true,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 263:
                this.setState({
                    silenceChannels: 263,
                    audioFL: true,
                    audioFC: true,
                    audioFR: true,
                    audioRL: false,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 272:
                this.setState({
                    silenceChannels: 272,
                    audioFL: false,
                    audioFC: false,
                    audioFR: false,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 273:
                this.setState({
                    silenceChannels: 273,
                    audioFL: true,
                    audioFC: false,
                    audioFR: false,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 274:
                this.setState({
                    silenceChannels: 274,
                    audioFL: false,
                    audioFC: true,
                    audioFR: false,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 275:
                this.setState({
                    silenceChannels: 275,
                    audioFL: true,
                    audioFC: true,
                    audioFR: false,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 276:
                this.setState({
                    silenceChannels: 276,
                    audioFL: false,
                    audioFC: false,
                    audioFR: true,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 277:
                this.setState({
                    silenceChannels: 277,
                    audioFL: true,
                    audioFC: false,
                    audioFR: true,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 278:
                this.setState({
                    silenceChannels: 278,
                    audioFL: false,
                    audioFC: true,
                    audioFR: true,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 279:
                this.setState({
                    silenceChannels: 279,
                    audioFL: true,
                    audioFC: true,
                    audioFR: true,
                    audioRL: true,
                    audioRR: false,
                    audioLFE: true
                });
                break;
            case 288:
                this.setState({
                    silenceChannels: 288,
                    audioFL: false,
                    audioFC: false,
                    audioFR: false,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 289:
                this.setState({
                    silenceChannels: 289,
                    audioFL: true,
                    audioFC: false,
                    audioFR: false,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 290:
                this.setState({
                    silenceChannels: 290,
                    audioFL: false,
                    audioFC: true,
                    audioFR: false,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 291:
                this.setState({
                    silenceChannels: 291,
                    audioFL: true,
                    audioFC: true,
                    audioFR: false,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 292:
                this.setState({
                    silenceChannels: 292,
                    audioFL: false,
                    audioFC: false,
                    audioFR: true,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 293:
                this.setState({
                    silenceChannels: 293,
                    audioFL: true,
                    audioFC: false,
                    audioFR: true,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 294:
                this.setState({
                    silenceChannels: 294,
                    audioFL: false,
                    audioFC: true,
                    audioFR: true,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 295:
                this.setState({
                    silenceChannels: 295,
                    audioFL: true,
                    audioFC: true,
                    audioFR: true,
                    audioRL: false,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 304:
                this.setState({
                    silenceChannels: 304,
                    audioFL: false,
                    audioFC: false,
                    audioFR: false,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 305:
                this.setState({
                    silenceChannels: 305,
                    audioFL: true,
                    audioFC: false,
                    audioFR: false,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 306:
                this.setState({
                    silenceChannels: 306,
                    audioFL: false,
                    audioFC: true,
                    audioFR: false,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 307:
                this.setState({
                    silenceChannels: 307,
                    audioFL: true,
                    audioFC: true,
                    audioFR: false,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 308:
                this.setState({
                    silenceChannels: 308,
                    audioFL: false,
                    audioFC: false,
                    audioFR: true,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 309:
                this.setState({
                    silenceChannels: 309,
                    audioFL: true,
                    audioFC: false,
                    audioFR: true,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 310:
                this.setState({
                    silenceChannels: 310,
                    audioFL: false,
                    audioFC: true,
                    audioFR: true,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: true
                });
                break;
            case 311:
                this.setState({
                    silenceChannels: 311,
                    audioFL: true,
                    audioFC: true,
                    audioFR: true,
                    audioRL: true,
                    audioRR: true,
                    audioLFE: true
                });
                break;
        }
        // console.log('getSilenceChannels: silenceChannels: ' + this.state.silenceChannels);
    }

    setSilenceChannels() {
        let FL, FC, FR, RL, RR, LFE;

        if (this.state.audioFL) {
            FL = 1;
        } else {
            FL = 0;
        }
        if (this.state.audioFC) {
            FC = 2;
        } else {
            FC = 0;
        }
        if (this.state.audioFR) {
            FR = 4;
        } else {
            FR = 0;
        }
        if (this.state.audioRL) {
            RL = 16;
        } else {
            RL = 0;
        }
        if (this.state.audioRR) {
            RR = 32;
        } else {
            RR = 0;
        }
        if (this.state.audioLFE) {
            LFE = 256;
        } else {
            LFE = 0;
        }

        let newChannels = FL + FC + FR + RL + RR + LFE;

        this.setState({
            silenceChannels: newChannels
        });
        // console.log('setSilenceChannels: ' + this.state.silenceChannels);
    }

    renderQoEConfig() {
        return (
            <OAuth.Context>
                {(userInfo: OAuthClientStatus) => (userInfo.QoELicensePresent)
                    ?
                    <div>
                        {(this.props.mode === 'All Segments' || this.props.mode === 'Dynamic Ad' || this.props.mode === 'VOD') &&
                        <React.Fragment>
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">QoE</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Video MOS
                                            </Label>
                                            <Label className="right-align-label-width120">
                                                Low Threshold
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="3"
                                                required
                                                hint="true"
                                                min="1.0"
                                                max="5.0"
                                                step=".1"
                                                value={this.state.mosVideoThreshValue}
                                                onChange={(e: any, data: any) => this.setState({mosVideoThreshValue: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.mosVideoThreshEnable}
                                                onChange={(e: any, data: any) => this.setState({mosVideoThreshEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                Duration Below Before Alarm (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.mosVideoDurError}
                                                onChange={(e: any, data: any) => this.setState({mosVideoDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-MOSV-UNDLEV
                                            </Label>
                                        </Form.Group>
                                        {(this.props.mode !== 'VOD') &&
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Contribute to Asset Availability
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.mosVideoAvailEnable}
                                                onChange={(e: any, data: any) => this.setState({mosVideoAvailEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                Duration Below Before Availability Impact (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.mosVideoAvailDurError}
                                                onChange={(e: any, data: any) => this.setState({mosVideoAvailDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-MOSV-UNDLEV-AA
                                            </Label>
                                        </Form.Group>}
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-150">
                                                GOP MOS
                                            </Label>
                                            <Label className="right-align-label-width170">
                                                MOS Threshold
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="3"
                                                required
                                                hint="true"
                                                min="1.0"
                                                max="5.0"
                                                step=".1"
                                                value={this.state.gopMosVideoThreshValue}
                                                onChange={(e: any, data: any) => this.setState({gopMosVideoThreshValue: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.gopMosVideoThreshEnable}
                                                onChange={(e: any, data: any) => this.setState({gopMosVideoThreshEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                Duration under MOS threshold before alarm (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.gopMosVideoDurError}
                                                onChange={(e: any, data: any) => this.setState({gopMosVideoDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                GMOSV-UNDLEV
                                            </Label>
                                        </Form.Group>
                                        {/*{(this.props.mode !== 'VOD') &&*/}
                                        {/*<Form.Group grouped>*/}
                                        {/*    <Label className="right-align-label-width320">*/}
                                        {/*        Contribute to Asset Availability*/}
                                        {/*    </Label>*/}
                                        {/*    <Checkbox*/}
                                        {/*        className="config-checkbox"*/}
                                        {/*        checked={this.state.gopMosVideoAvailEnable}*/}
                                        {/*        onChange={(e: any, data: any) => this.setState({gopMosVideoAvailEnable: data.checked})}*/}
                                        {/*    />*/}
                                        {/*    <Label className="segment-config-description">*/}
                                        {/*        GMOSV-UNDLEV-AA*/}
                                        {/*    </Label>*/}
                                        {/*</Form.Group>}*/}
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Black Screen
                                            </Label>
                                            <Label className="right-align-label-width120">
                                                Percentage of
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="3"
                                                required
                                                hint="true"
                                                min="10"
                                                max="100"
                                                value={this.state.blacknessThreshValue}
                                                onChange={(e: any, data: any) => this.setState({blacknessThreshValue: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.blacknessThreshEnable}
                                                onChange={(e: any, data: any) => this.setState({blacknessThreshEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                Duration Over Before Alarm (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.blacknessDurError}
                                                onChange={(e: any, data: any) => this.setState({blacknessDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-BLACK-SCREEN
                                            </Label>
                                        </Form.Group>
                                        {(this.props.mode !== 'VOD') &&
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Contribute to Asset Availability
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.blacknessAvailEnable}
                                                onChange={(e: any, data: any) => this.setState({blacknessAvailEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                Duration Over Before Availability Impact (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.blacknessAvailDurError}
                                                onChange={(e: any, data: any) => this.setState({blacknessAvailDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-BLACK-SCREEN-AA
                                            </Label>
                                        </Form.Group>}
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Still Frame
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                When less than
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="2"
                                                required
                                                hint="true"
                                                min="0"
                                                max="50"
                                                value={this.state.stillnessThreshValue}
                                                onChange={(e: any, data: any) => this.setState({stillnessThreshValue: data.value})}
                                            />
                                            <Label className="left-align-label-300">
                                                % of the screen is changing
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.stillnessThreshEnable}
                                                onChange={(e: any, data: any) => this.setState({stillnessThreshEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                When condition occurs for longer than (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.stillnessDurError}
                                                onChange={(e: any, data: any) => this.setState({stillnessDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-STILL-FRAME
                                            </Label>
                                        </Form.Group>
                                        {(this.props.mode !== 'VOD') &&
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Contribute to Asset Availability
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.stillnessAvailEnable}
                                                onChange={(e: any, data: any) => this.setState({stillnessAvailEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                When condition occurs for longer than (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.stillnessAvailDurError}
                                                onChange={(e: any, data: any) => this.setState({stillnessAvailDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-STILL-FRAME-AA
                                            </Label>
                                        </Form.Group>
                                        }
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Block Artifact Level<br />
                                                [ Requires pixel analysis ]
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Blockiness Threshold (0-100)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="2"
                                                required
                                                hint="true"
                                                min="0"
                                                max="100"
                                                value={this.state.pixelAnalysisThresholdValue}
                                                onChange={(e: any, data: any) => this.setState({pixelAnalysisThresholdValue: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.pixelAnalysisThresholdEnable}
                                                onChange={(e: any, data: any) => this.setState({pixelAnalysisThresholdEnable: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-PIXEL-BLOCK-ARTIFACT
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Duration Over Threshold Before Alarm (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                value={this.state.pixelAnalysisDurationError}
                                                onChange={(e: any, data: any) => this.setState({pixelAnalysisDurationError: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Audio MOS
                                            </Label>
                                            <Label className="right-align-label-width120">
                                                Low Threshold
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="3"
                                                required
                                                hint="true"
                                                min="1.0"
                                                max="5.0"
                                                step=".1"
                                                value={this.state.mosAudioThreshValue}
                                                onChange={(e: any, data: any) => this.setState({mosAudioThreshValue: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.mosAudioThreshEnable}
                                                onChange={(e: any, data: any) => this.setState({mosAudioThreshEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                Duration Below Before Alarm (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.mosAudioDurError}
                                                onChange={(e: any, data: any) => this.setState({mosAudioDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-MOSA-UNDLEV
                                            </Label>
                                        </Form.Group>
                                        {(this.props.mode !== 'VOD') &&
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Contribute to Asset Availability
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.mosAudioAvailEnable}
                                                onChange={(e: any, data: any) => this.setState({mosAudioAvailEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                Duration Below Before Availability Impact (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.mosAudioAvailDurError}
                                                onChange={(e: any, data: any) => this.setState({mosAudioAvailDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-MOSA-UNDLEV-AA
                                            </Label>
                                        </Form.Group>}
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Loudness
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200"/>
                                            <Label className="right-align-label-width120">
                                                'Min' Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.audioLoudnessMinEnable}
                                                onChange={(e: any, data: any) => this.setState({audioLoudnessMinEnable: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-LOUD-UNDLEV
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Min Threshold (LKFS)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="-100"
                                                max="20"
                                                value={this.state.audioLoudnessMinValue}
                                                onChange={(e: any, data: any) => this.setState({audioLoudnessMinValue: data.value})}
                                            />
                                            <Label  className="right-align-label-width333">
                                                Duration Below Before Alarm (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.audioLoudnessMinDuration}
                                                onChange={(e: any, data: any) => this.setState({audioLoudnessMinDuration: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200"/>
                                            <Label className="right-align-label-width120">
                                                'Max' Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.audioLoudnessMaxEnable}
                                                onChange={(e: any, data: any) => this.setState({audioLoudnessMaxEnable: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-LOUD-OVRLEV
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Max Threshold (LKFS)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="-100"
                                                max="20"
                                                value={this.state.audioLoudnessMaxValue}
                                                onChange={(e: any, data: any) => this.setState({audioLoudnessMaxValue: data.value})}
                                            />
                                            <Label className="right-align-label-width333">
                                                Duration Over Before Alarm (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.audioLoudnessMaxDuration}
                                                onChange={(e: any, data: any) => this.setState({audioLoudnessMaxDuration: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Loudness-Dialnorm Deviation
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200"/>
                                            <Label className="right-align-label-width120">
                                                'Max' Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dialnormDevEnable}
                                                onChange={(e: any, data: any) => this.setState({dialnormDevEnable: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-DN-DEV-HIGH
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Target Loudness (LKFS)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="3"
                                                required
                                                hint="true"
                                                min="-100"
                                                max="20"
                                                value={this.state.targetLoudnessValue}
                                                onChange={(e: any, data: any) => this.setState({targetLoudnessValue: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Maximum Deviation (LKFS)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="3"
                                                required
                                                hint="true"
                                                min="0"
                                                max="100"
                                                value={this.state.dialnormDevValue}
                                                onChange={(e: any, data: any) => this.setState({dialnormDevValue: data.value})}
                                            />
                                            <Label  className="right-align-label-width300">
                                                Duration Over Deviation Before Alarm (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.dialnormDevDuration}
                                                onChange={(e: any, data: any) => this.setState({dialnormDevDuration: data.value})}
                                            />
                                        </Form.Group>
                                        {(this.props.mode !== 'VOD') &&
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Contribute to Asset Availability
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dialnormDevAvailEnable}
                                                onChange={(e: any, data: any) => this.setState({dialnormDevAvailEnable: data.checked})}
                                            />
                                            <Label className="right-align-label-width400">
                                                Duration Over Before Availability Impact (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.dialnormDevAvailValue}
                                                onChange={(e: any, data: any) => this.setState({dialnormDevAvailValue: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-DN-DEV-HIGH-AA
                                            </Label>
                                        </Form.Group>}
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Silence
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200"/>
                                            <Label className="right-align-label-width120">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.silenceAlarmEnable}
                                                onChange={(e: any, data: any) => this.setState({silenceAlarmEnable: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-AUD-SILEN
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped className="radio-group-heading">
                                            <Label className="right-align-label-width320">
                                                Detection Mode
                                            </Label>
                                            <Radio
                                                label="All Silent"
                                                className="radio-group"
                                                name="radioGroup1"
                                                value={0}
                                                checked={this.state.silenceDetectMode === 0}
                                                onChange={(e: any, data: any) => this.setState({silenceDetectMode: data.value})}
                                            />
                                            <Label className="right-align-label-width30" />
                                            <Radio
                                                label="Any Silent"
                                                className="radio-group"
                                                name="radioGroup1"
                                                value={1}
                                                checked={this.state.silenceDetectMode === 1}
                                                onChange={(e: any, data: any) => this.setState({silenceDetectMode: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Audio Channels for Alarm Trigger
                                            </Label>
                                            <Label>
                                                FL
                                            </Label>
                                            <Checkbox
                                                // label="FL"
                                                className="config-checkbox"
                                                checked={this.state.audioFL}
                                                onChange={(e: any, data: any) => this.setState({audioFL: data.checked})}
                                            />
                                            <Label>
                                                FC
                                            </Label>
                                            <Checkbox
                                                // label="FC"
                                                className="config-checkbox"
                                                checked={this.state.audioFC}
                                                onChange={(e: any, data: any) => this.setState({audioFC: data.checked})}
                                            />
                                            <Label>
                                                FR
                                            </Label>
                                            <Checkbox
                                                // label="FR"
                                                className="config-checkbox"
                                                checked={this.state.audioFR}
                                                onChange={(e: any, data: any) => this.setState({audioFR: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320"/>
                                            <Label>
                                                RL
                                            </Label>
                                            <Checkbox
                                                // label="RL"
                                                className="config-checkbox"
                                                checked={this.state.audioRL}
                                                onChange={(e: any, data: any) => this.setState({audioRL: data.checked})}
                                            />
                                            <Label>
                                                RR
                                            </Label>
                                            <Checkbox
                                                // label="RR"
                                                className="config-checkbox"
                                                checked={this.state.audioRR}
                                                onChange={(e: any, data: any) => this.setState({audioRR: data.checked})}
                                            />
                                            <Label>
                                                LFE
                                            </Label>
                                            <Checkbox
                                                // label="LFE"
                                                className="config-checkbox"
                                                checked={this.state.audioLFE}
                                                onChange={(e: any, data: any) => this.setState({audioLFE: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                Duration Below Before Alarm (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.silenceAlarmDuration}
                                                onChange={(e: any, data: any) => this.setState({silenceAlarmDuration: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Thumbnail Archive
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                Video MOS
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.mosVideoErrors}
                                                onChange={(e: any, data: any) => this.setState({mosVideoErrors: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-MOSV-UNDLEV
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                GOP MOS
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.mosGopError}
                                                onChange={(e: any, data: any) => this.setState({mosGopError: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-GMOSV-UNDLEV
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                Black Screen
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.blacknessErrors}
                                                onChange={(e: any, data: any) => this.setState({blacknessErrors: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-BLACK-SCREEN
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                Still Frame
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.stillnessErrors}
                                                onChange={(e: any, data: any) => this.setState({stillnessErrors: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-STILL-FRAME
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width320">
                                                Block Artifact Level
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.pixelAnalysisVODThumbnailArchive}
                                                onChange={(e: any, data: any) => this.setState({pixelAnalysisVODThumbnailArchive: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-PIXEL-ANALYSIS
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                Audio MOS
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.mosAudioError}
                                                onChange={(e: any, data: any) => this.setState({mosAudioError: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-MOSA-UNDLEV
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                Loudness 'Min'
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.minAudioLoudnessErrors}
                                                onChange={(e: any, data: any) => this.setState({minAudioLoudnessErrors: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-LOUD-UNDLEV
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                Loudness 'Max'
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.maxAudioLoudnessErrors}
                                                onChange={(e: any, data: any) => this.setState({maxAudioLoudnessErrors: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-LOUD-OVRLEV
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                Loudness-Dialnorm Deviation
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.dialNormDevError}
                                                onChange={(e: any, data: any) => this.setState({dialNormDevError: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-DN-DEV-HIGH
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label  className="right-align-label-width320">
                                                Silence
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.audioSilenceError}
                                                onChange={(e: any, data: any) => this.setState({audioSilenceError: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                QOE-AUD-SILEN
                                            </Label>
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                        </React.Fragment>
                        }
                        {(this.props.mode === 'Sample' || this.props.mode === 'Header Only') &&
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">QoE alarms are not valid for {this.props.mode} mode</Segment>
                        </Segment.Group>
                        }
                    </div>
                    :  <Segment.Group className="system-config-segment">
                        <Segment className="segment-header">System is not licensed for QoE</Segment>
                    </Segment.Group>}
            </OAuth.Context>

        );
    }
    // DAI Start Time
    handleStartTimeChange (value: any, index: any) {
        let schedules = [...this.state.schedules];
        schedules[index].start = value;

        this.setState({schedules});
    }
    // DAI End Time
    handleEndTimeChange (value: any, index: any) {
        let schedules = [...this.state.schedules];
        schedules[index].end = value;

        this.setState({schedules});
    }
    // DAI Threshold
    handleThresholdChange (value: any, index: any) {
        let schedules = [...this.state.schedules];
        schedules[index].threshold = value;

        this.setState({schedules});
    }
    // Add Default entry for schedule
    addSchedule(index: any) {
        this.setState((prevState) => ({
            schedules: [...prevState.schedules, {start: 0, end: 1, threshold: 60}],
        }));
    }
    // Remove current schedule
    removeSchedules() {
        let schedules: never[] = [];
        this.setState({schedules});
    }
    // Remove current schedule
    removeSchedule(index: any) {
        let schedules = [...this.state.schedules]; // make a separate copy of the array
        schedules.splice(index, 1);
        this.setState({schedules});
    }

    renderSchedules() {
        const timeOptions = [
            {text: '00:00', value: 0},
            {text: '01:00', value: 1},
            {text: '02:00', value: 2},
            {text: '03:00', value: 3},
            {text: '04:00', value: 4},
            {text: '05:00', value: 5},
            {text: '06:00', value: 6},
            {text: '07:00', value: 7},
            {text: '08:00', value: 8},
            {text: '09:00', value: 9},
            {text: '10:00', value: 10},
            {text: '11:00', value: 11},
            {text: '12:00', value: 12},
            {text: '13:00', value: 13},
            {text: '14:00', value: 14},
            {text: '15:00', value: 15},
            {text: '16:00', value: 16},
            {text: '17:00', value: 17},
            {text: '18:00', value: 18},
            {text: '19:00', value: 19},
            {text: '20:00', value: 20},
            {text: '21:00', value: 21},
            {text: '22:00', value: 22},
            {text: '23:00', value: 23},
            {text: '24:00', value: 24}
        ];
        let options = [];
        for (let idx = 0; idx < Object.keys(this.state.schedules).length; idx++) {
            let startId = `start-${idx}`, endId = `end-${idx}`, thresholdId = `threshold-${idx}`;
            options.push((
                    <Form.Group grouped>
                        <Label className="right-align-label-width320">
                            Start Time
                        </Label>
                        <Dropdown
                            className="templateDropDown"
                            search
                            selection
                            name={startId}
                            data-id={idx}
                            id={startId}
                            options={timeOptions}
                            value={this.state.schedules[idx].start}
                            onChange={(event, data) => this.handleStartTimeChange(data.value, idx)}
                        />
                        <Label className="right-align-label-width120">
                            End Time
                        </Label>
                        <Dropdown
                            className="templateDropDown2"
                            search
                            selection
                            name={endId}
                            data-id={idx}
                            id={endId}
                            options={timeOptions}
                            value={this.state.schedules[idx].end}
                            onChange={(event, data) => this.handleEndTimeChange(data.value, idx)}
                        />
                        <Label className="right-align-label-width120">
                            Threshold
                        </Label>
                        <Input
                            type="number"
                            name={thresholdId}
                            data-id={idx}
                            id={thresholdId}
                            maxLength="4"
                            required
                            hint="true"
                            min="1"
                            max="9999"
                            value={this.state.schedules[idx].threshold}
                            onChange={(event, data) => this.handleThresholdChange(data.value, idx)}
                        />
                        <Label className="right-align-label-width30">
                            (minutes)
                        </Label>
                        <Button
                            floated="right"
                            className="rightButton"
                            disabled={Object.keys(this.state.schedules).length === 0}
                            content="Remove"
                            title="Remove Schedule"
                            onClick={() => this.removeSchedule(idx)}
                        />
                    </Form.Group>
            ));
        }
        return <div>{options}</div>;
    }

    renderDAIConfig() {
        return (
            <OAuth.Context>
                {(userInfo: OAuthClientStatus) => (userInfo.DAILicensePresent)
                    ?
                    <div>
                        {(this.props.mode !== 'Sample' && this.props.mode !== 'VOD') &&
                        <React.Fragment>
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">DAI</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-300">
                                                Interval
                                            </Label>
                                            <Label className="right-align-label-width250">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.spliceAlarmEnable}
                                                onChange={(e: any, data: any) => this.setState({spliceAlarmEnable: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Splice Events Schedule
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            {this.renderSchedules()}
                                        </Form.Group>
                                        <Form.Group>
                                            <Button
                                                floated="right"
                                                className="rightButton"
                                                disabled={Object.keys(this.state.schedules).length < 6 ? false : true}
                                                content="Add"
                                                title="Add Schedule"
                                                onClick={() => this.addSchedule(Object.keys(this.state.schedules).length)}
                                            />
                                            <Button
                                                floated="right"
                                                className="rightButton"
                                                disabled={Object.keys(this.state.schedules).length === 0 ? true : false}
                                                content="Remove All"
                                                title="Remove All Schedules"
                                                onClick={() => this.removeSchedules()}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-300">
                                                Sequence
                                            </Label>
                                            <Label className="right-align-label-width250">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.spliceSeqAlarmEnable}
                                                onChange={(e: any, data: any) => this.setState({spliceSeqAlarmEnable: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Alarm Duration (mins)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.spliceSeqAlarmDurError}
                                                onChange={(e: any, data: any) => this.setState({spliceSeqAlarmDurError: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                ADSPLICE-SEQUENCE
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                When an IN appears without an OUT
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.spliceSeqAlarmInNoOutMode}
                                                onChange={(e: any, data: any) => this.setState({spliceSeqAlarmInNoOutMode: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                When an OUT appears without and IN
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.spliceSeqAlarmOutNoInMode}
                                                onChange={(e: any, data: any) => this.setState({spliceSeqAlarmOutNoInMode: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-300">
                                                Media Segment Duration
                                            </Label>
                                            <Label className="right-align-label-width250">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.mfDurMinEnable}
                                                onChange={(e: any, data: any) => this.setState({mfDurMinEnable: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Media file before ad break is less than
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="10"
                                                required
                                                hint="true"
                                                min="1"
                                                max="2147483647"
                                                value={this.state.mfDurMinValue}
                                                onChange={(e: any, data: any) => this.setState({mfDurMinValue: data.value})}
                                            />
                                            <Label className="right-align-label-width190">
                                                milliseconds in duration.
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Alarm Duration (mins)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.mfDurMinDuration}
                                                onChange={(e: any, data: any) => this.setState({mfDurMinDuration: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                ADMEDIA-DUR-MIN
                                            </Label>
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-200">
                                                Playback Duration
                                            </Label>
                                            <Label className="right-align-label-width275">
                                                Splice Out Duration (secs)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.spliceOutDur}
                                                onChange={(e: any, data: any) => this.setState({spliceOutDur: data.value})}
                                            />
                                            <Label className="segment-config-description">
                                                ADPLAYBACK-DURATION
                                            </Label>
                                        </Form.Group>
                                        <fieldset id="fieldSet1" className="field-set">
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width450">
                                                    Enable Playback Under Alarm
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.underThresholdEnable}
                                                    onChange={(e: any, data: any) => this.setState({underThresholdEnable: data.checked})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width450">
                                                    Media is more than
                                                </Label>
                                                <Input
                                                    id="small-input-leftMargin"
                                                    type="number"
                                                    maxLength="4"
                                                    required
                                                    hint="true"
                                                    min="1"
                                                    max="9999"
                                                    value={this.state.underThresholdValue}
                                                    onChange={(e: any, data: any) => this.setState({underThresholdValue: data.value})}
                                                />
                                                <Label className="right-align-label-width310">
                                                    seconds under the advertisement duration.
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width450">
                                                    Alarm Duration (mins)
                                                </Label>
                                                <Input
                                                    id="small-input-leftMargin"
                                                    type="number"
                                                    maxLength="4"
                                                    required
                                                    hint="true"
                                                    min="1"
                                                    max="9999"
                                                    value={this.state.underDuration}
                                                    onChange={(e: any, data: any) => this.setState({underDuration: data.value})}
                                                />
                                                <Label className="segment-config-description">
                                                    ADPLAYBACK-UNDER-DUR
                                                </Label>
                                            </Form.Group>
                                        </fieldset>
                                        <div className="spacerFS"/>
                                        <fieldset id="fieldSet2" className="field-set">
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width450">
                                                    Enable Playback Over Alarm
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.overThresholdEnable}
                                                    onChange={(e: any, data: any) => this.setState({overThresholdEnable: data.checked})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width450">
                                                    Media is more than
                                                </Label>
                                                <Input
                                                    id="small-input-leftMargin"
                                                    type="number"
                                                    maxLength="4"
                                                    required
                                                    hint="true"
                                                    min="1"
                                                    max="9999"
                                                    value={this.state.overThresholdValue}
                                                    onChange={(e: any, data: any) => this.setState({overThresholdValue: data.value})}
                                                />
                                                <Label className="right-align-label-width310">
                                                    seconds over the advertisement duration.
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width450">
                                                    Alarm Duration (mins)
                                                </Label>
                                                <Input
                                                    id="small-input-leftMargin"
                                                    type="number"
                                                    maxLength="4"
                                                    required
                                                    hint="true"
                                                    min="1"
                                                    max="9999"
                                                    value={this.state.overDuration}
                                                    onChange={(e: any, data: any) => this.setState({overDuration: data.value})}
                                                />
                                                <Label className="segment-config-description">
                                                    ADPLAYBACK-OVER-DUR
                                                </Label>
                                            </Form.Group>
                                        </fieldset>
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        {this.props.mode !== 'Header Only' &&
                                        <Form.Group grouped>
                                            <Label className="segment-section-header-300">
                                                Format Mismatch
                                            </Label>
                                            <Label className="right-align-label-width250">
                                                Enable Alarm
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.formatMismatchEnable}
                                                onChange={(e: any, data: any) => this.setState({formatMismatchEnable: data.checked})}
                                            />
                                            <Label className="segment-config-description">
                                                ADFORMAT-MISMATCH
                                            </Label>
                                        </Form.Group>
                                        }
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Alarm Duration (mins)
                                            </Label>
                                            <Input
                                                id="small-input-leftMargin"
                                                type="number"
                                                maxLength="4"
                                                required
                                                hint="true"
                                                min="1"
                                                max="9999"
                                                value={this.state.formatDurError}
                                                onChange={(e: any, data: any) => this.setState({formatDurError: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550 headingStyle">
                                                Comparison Modes
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Manifest
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.manifestMode}
                                                onChange={(e: any, data: any) => this.setState({manifestMode: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Media File
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.fileMode}
                                                onChange={(e: any, data: any) => this.setState({fileMode: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550 headingStyle">
                                                Characteristics
                                            </Label>
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Video Codec
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.videoCodecChar}
                                                onChange={(e: any, data: any) => this.setState({videoCodecChar: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Video Resolution
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.videoResChar}
                                                onChange={(e: any, data: any) => this.setState({videoResChar: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width550">
                                                Audio Sampling Rate
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.audioSampChar}
                                                onChange={(e: any, data: any) => this.setState({audioSampChar: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                        </React.Fragment>
                        }
                        {(this.props.mode === 'Sample' || this.props.mode === 'VOD') &&
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">DAI alarms are not valid for {this.props.mode} mode</Segment>
                        </Segment.Group>
                        }
                    </div>
                    :  <Segment.Group className="system-config-segment">
                        <Segment className="segment-header">System is not licensed for DAI</Segment>
                    </Segment.Group>}
            </OAuth.Context>
        );
    }

    render() {
        const inlineStyle = {
            modal : {
                marginTop: '50px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const panes = [
            { menuItem: 'Video Startup', render: this.renderDVSConfig},
            { menuItem: 'DNS', render: this.renderDNSConfig},
            { menuItem: 'TCP', render: this.renderTCPConfig },
            { menuItem: 'HTTP', render: this.renderHTTPConfig },
            { menuItem: 'Playlist / Manifest File', render: this.renderManifestConfig },
            { menuItem: 'Media Files', render: this.renderMediaFilesConfig },
            { menuItem: 'Streaming Performance', render: this.renderVSConfig },
            { menuItem: 'Text (Caption/Subtitle) File', render: this.renderTextFileConfig },
            { menuItem: 'QoE', render: this.renderQoEConfig },
            { menuItem: 'DAI', render: this.renderDAIConfig }
        ];
        return (
            <React.Fragment>
                <div className="alarmTemplateFilters">
                    <Label className="system-config-label">
                        Alarm Template Configurator ({this.props.mode})
                    </Label>
                    <Label className="system-config-label">
                        Template Name:
                    </Label>
                    <Input
                        className="template-name"
                        style={{ width: 350 }}
                        value={this.state.templateName}
                        onChange={(e: any, data: any) => this.setState({templateName: data.value})}
                    />
                    {this.state.qoeLicensePresent ?
                        <Button
                            floated="right"
                            className="rightButton"
                            content="Apply"
                            title="Update Config"
                            onClick={() => this.validateQoE()}
                        />
                        :
                        <Button
                            floated="right"
                            className="rightButton"
                            content="Apply"
                            title="Update Config"
                            onClick={() => this.transformVariants()}
                        />}
                </div>
                <div className="vertical-flex-main">
                    <Tab panes={panes} />
                </div>
                <Modal
                    open={this.state.showModal}
                    onClose={this.handleWarningClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Template Overwrite!</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field>
                                A template named <i>'{this.state.templateName}'</i> already exists. Do you want to replace it?
                            </Form.Field>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-secondary-btn modal-button-padding" onClick={this.update}>
                            Yes
                        </Button>
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleWarningClose}>
                            Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.showValidateModal}
                    onClose={this.handleValidateModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Error!</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field>
                                The Variants Required configuration has an error. Please correct the configuration and hit Apply.
                            </Form.Field>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleValidateModalClose}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.showErrorModal}
                    onClose={this.handleErrorModalClose}
                    size="mini"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Error!</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Field>
                                {this.state.errorMessage}
                            </Form.Field>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleErrorModalClose}>
                            OK
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.showGuideModal}
                    onClose={this.handleGuideModalClose}
                    size="large"
                    style={inlineStyle.modal}
                >
                    <Modal.Header>Guided Configuration: Buffer & Gear Change Conditions & Alarms</Modal.Header>
                    <Modal.Content>
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">Step 1: Media & Media Buffer</Segment>
                            <Segment>
                                <Form>
                                    <Form.Field>
                                        Based on the media file size and expected media buffer, we can determine a best fit for configuring VeriStream values that will align with buffer and gear change conditions.
                                    </Form.Field>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-width450">
                                            What is the average duration of a media file?
                                        </Label>
                                        <Input
                                            maxLength={8}
                                            className="small-input-radio-leftMargin"
                                            value={this.state.mediaDuration}
                                            onChange={(e: any, data: any) => this.setState({mediaDuration: data.value})}
                                        />
                                        <Label className="right-align-label-small">
                                            seconds.
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-width450">
                                            How much media (in terms of video duration) is expected to be kept in buffer for smooth playback at the ideal bitrate?
                                        </Label>
                                        <Input
                                            maxLength={8}
                                            className="small-input-radio-leftMargin"
                                            value={this.state.mediaBuffer}
                                            onChange={(e: any, data: any) => this.setState({mediaBuffer: data.value})}
                                        />
                                        <Label className="right-align-label-small">
                                            seconds.
                                        </Label>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </Segment.Group>
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">Step 2: (Optional): Define Percent of Media Buffer</Segment>
                            <Segment>
                                <Form>
                                    <Form.Field>
                                        {/* tslint:disable-next-line:max-line-length */}
                                        To make alarm conditions more predictive in nature, you can optionally define a percentage of the media buffer depletion that would be considered cause for concern. Left unconfigured, alarms will be based on the media buffer configured in Step 1.                                    </Form.Field>
                                    <Form.Group grouped>
                                        <Checkbox
                                            label={'Don’t let the full media buffer rundown before raising alarm conditions. Instead, alert me when streaming performance is close to impacting my client devices.'}
                                            className="config-checkbox-left"
                                            checked={this.state.mediaBufferOption}
                                            onChange={(e: any, data: any) => this.setState({mediaBufferOption: data.checked})}
                                        />
                                    </Form.Group>
                                    {/* tslint:disable-next-line:max-line-length */}
                                    {this.state.badMediaThresholdTmp && this.state.goodMediaThresholdTmp && (this.state.badMediaThresholdTmp > this.state.goodMediaThresholdTmp || this.state.badMediaThresholdTmp === this.state.goodMediaThresholdTmp) && this.state.mediaBufferOption &&
                                    <Form.Group grouped>
                                        <Label className="right-align-label-width500-red">
                                            Note: "Decreases" number must be lower than "Increases" number.
                                        </Label>
                                    </Form.Group> }
                                    <Form.Group grouped>
                                        <Label className="right-align-label-width310">
                                            When the media buffer decreases to
                                        </Label>
                                        <Input
                                            disabled={!this.state.mediaBufferOption}
                                            // type="number"
                                            // min="1"
                                            // max="99"
                                            maxLength={3}
                                            className="small-input-radio-leftMargin"
                                            value={this.state.badMediaThresholdTmp}
                                            onChange={(event, data) => this.setVSPerc(event, data, 1)}
                                        />
                                        <Label className="left-align-label-500">
                                            percent, consider this a buffer/gear change failure condition.
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="right-align-label-width310">
                                            When the media buffer increases to
                                        </Label>
                                        <Input
                                            disabled={!this.state.mediaBufferOption}
                                            // type="number"
                                            // min="1"
                                            // max="100"
                                            maxLength={3}
                                            className="small-input-radio-leftMargin"
                                            value={this.state.goodMediaThresholdTmp}
                                            onChange={(event, data) => this.setVSPerc(event, data, 2)}
                                        />
                                        <Label className="left-align-label-500">
                                            percent, the failure condition is over.
                                        </Label>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </Segment.Group>
                        <Segment.Group className="system-config-segment">
                            <Segment className="segment-header">Step 3: Conditions that you want to raise an alarm</Segment>
                            <Segment>
                                <Form>
                                    <Form.Group grouped>
                                        <Checkbox
                                            label={'When the buffer or gear change event lasts longer than '}
                                            className="config-checkbox-left"
                                            checked={this.state.veristreamBufferThreshEnableTmp}
                                            onChange={(e: any, data: any) => this.setState({veristreamBufferThreshEnableTmp: data.checked})}
                                        />
                                        <Input
                                            disabled={!this.state.veristreamBufferThreshEnableTmp}
                                            maxLength={8}
                                            className="small-input"
                                            value={this.state.veristreamBufferThreshValueTmp}
                                            onChange={(e: any, data: any) => this.setState({veristreamBufferThreshValueTmp: data.value})}
                                        />
                                        <Label className="right-align-label-small">
                                            seconds.
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Label className="segment-section-header-300">
                                            Frequency of events –
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Checkbox
                                            label={'When there are more than'}
                                            className="config-checkbox-left"
                                            checked={this.state.veristreamBufferWinThreshEnableTmp}
                                            onChange={(e: any, data: any) => this.setState({veristreamBufferWinThreshEnableTmp: data.checked})}
                                        />
                                        <Input
                                            disabled={!this.state.veristreamBufferWinThreshEnableTmp}
                                            className="small-input"
                                            maxLength={8}
                                            value={this.state.veristreamBufferWinThreshValueTmp}
                                            onChange={(e: any, data: any) => this.setState({veristreamBufferWinThreshValueTmp: data.value})}
                                        />
                                        <Label className="left-align-label-300">
                                            buffer or gear change events in a
                                        </Label>
                                        <Input
                                            disabled={!this.state.veristreamBufferWinThreshEnableTmp}
                                            className="small-input"
                                            maxLength={8}
                                            value={this.state.veristreamBufferWinSizeTmp}
                                            onChange={(e: any, data: any) => this.setState({veristreamBufferWinSizeTmp: data.value})}
                                        />
                                        <Label className="left-align-label">
                                            minute sliding window.
                                        </Label>
                                    </Form.Group>
                                    <Form.Group grouped>
                                        <Checkbox
                                            label={'When there are more than '}
                                            className="config-checkbox-left"
                                            checked={this.state.veristreamBufferMax15EnableTmp}
                                            onChange={(e: any, data: any) => this.setState({veristreamBufferMax15EnableTmp: data.checked})}
                                        />
                                        <Input
                                            disabled={!this.state.veristreamBufferMax15EnableTmp}
                                            className="small-input"
                                            maxLength={8}
                                            value={this.state.veristreamBufferMax15ValueTmp}
                                            onChange={(e: any, data: any) => this.setState({veristreamBufferMax15ValueTmp: data.value})}
                                        />
                                        <Label className="left-align-label-400">
                                            buffer or gear change events in a 15-minute interval.
                                        </Label>
                                        <Label className="right-align-label-width800">
                                            Note: This condition could be raised four times in an hour and will clear at the 15-minute interval boundary.
                                        </Label>
                                    </Form.Group>
                                </Form>
                            </Segment>
                        </Segment.Group>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            className="filterPanel-primary-btn modal-button-padding"
                            onClick={this.setVSValues}
                            disabled={this.state.badMediaThresholdTmp && this.state.goodMediaThresholdTmp && (this.state.badMediaThresholdTmp > this.state.goodMediaThresholdTmp || this.state.badMediaThresholdTmp === this.state.goodMediaThresholdTmp) && this.state.mediaBufferOption ? true : false}
                            content="OK"
                            title="OK"
                        />
                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleGuideModalClose}>
                            Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>
            </React.Fragment>
        );
    }
    handleWarningClose() {
        this.setState({
            showModal: false
        });
    }
    handleValidateModalClose() {
        this.setState({
            showValidateModal: false
        });
    }
    handleErrorModalClose() {
        this.setState({
            showErrorModal: false,
            errorMessage: ''
        });
    }

    setVSPerc(event: any, data: any, type: number) {
        if (type === 1) {
            // @ts-ignore
            if (data) {
                if (isNaN(data.value) || data.value === '' || data.value < 0 || data.value === '0' || data.value > 99) {
                    this.setState({badMediaThresholdTmp: 99});
                } else {
                    this.setState({badMediaThresholdTmp: data.value});
                }
            } else {
                this.setState({badMediaThresholdTmp: 99});
            }
        } else {
            if (data) {
                if (isNaN(data.value) || data.value === '' || data.value < 0 || data.value === '0' || data.value > 100) {
                    this.setState({goodMediaThresholdTmp: 100});
                } else {
                    this.setState({goodMediaThresholdTmp: data.value});
                }
            } else {
                this.setState({goodMediaThresholdTmp: 100});
            }
        }
    }

    setVSValues() {
        // figure out error period start/end values
        let start: number; let end: number;
        let good = 100; let bad = 99;

        if (!this.state.mediaBufferOption) {
            // good = 100;
            // bad = 99;
        } else {
            good = this.state.goodMediaThresholdTmp ? this.state.goodMediaThresholdTmp : 100;
            bad = this.state.badMediaThresholdTmp ? this.state.badMediaThresholdTmp : 99;

            if (bad === 100) {
                // @ts-ignore
                start = Math.round(this.state.mediaBuffer / this.state.mediaDuration);
            } else {
                // @ts-ignore
                start = Math.round(this.state.mediaBuffer * (1 - (bad / 100)) / this.state.mediaDuration);
            }

            if (good === 100) {
                // @ts-ignore
                end = Math.round(this.state.mediaBuffer / this.state.mediaDuration);
            } else {
                // @ts-ignore
                end = Math.round(this.state.mediaBuffer * (good / 100) / this.state.mediaDuration);
            }
            this.setState({
                veristreamMaxEP: start,
                veristreamMaxED: end
            });
        }

        this.setState({
          badMediaThreshold: this.state.badMediaThresholdTmp,
          goodMediaThreshold: this.state.goodMediaThresholdTmp,
          veristreamBufferThreshEnable: this.state.veristreamBufferThreshEnableTmp,
          veristreamBufferThreshValue: this.state.veristreamBufferThreshValueTmp,
          veristreamBufferWinThreshEnable: this.state.veristreamBufferWinThreshEnableTmp,
          veristreamBufferWinThreshValue: this.state.veristreamBufferWinThreshValueTmp,
          veristreamBufferWinSize: this.state.veristreamBufferWinSizeTmp,
          veristreamBufferMax15Enable: this.state.veristreamBufferMax15EnableTmp,
          veristreamBufferMax15Value: this.state.veristreamBufferMax15ValueTmp,
          showGuideModal: false
        });
    }
    handleGuideModalClose() {
        this.setState({
          showGuideModal: false
        });
    }
    fetchData(option ?: string) {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let templateName = this.props.templateName;
        if (option === 'new') {
            templateName = 'streamDefault';
        }
        let url = 'http://default/api/config/templates/adp/alarm/' + encodeURIComponent(templateName);
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.template !== undefined) {
                    let data = response.data.template;
                    __this.setState({
                        templateName: (option === 'new' ? '' : data.name),
                        mode: data.mode,
                        mediaReceiveDurationMode: data.videoStartup.mediaReceiveDuration.mode,
                        mediaReceiveDurationFile: data.videoStartup.mediaReceiveDuration.file,
                        mediaReceiveDurationTime: data.videoStartup.mediaReceiveDuration.time,

                        derivedVariantStartupTimeEnable: data.videoStartup.derivedVariantStartupTime.enable,
                        derivedVariantStartupTimeThreshold: data.videoStartup.derivedVariantStartupTime.errorThreshold,
                        dvstRecalcEnable: data.videoStartup.derivedVariantStartupTime.recalcEnable,
                        dvstAlarmDuration: data.videoStartup.derivedVariantStartupTime.alarmDuration,

                        videoStartFailureEnable: data.videoStartup.videoStartFailure.enable,
                        videoStartFailureThreshold:  data.videoStartup.videoStartFailure.threshold,
                        videoStartFailureAvailability:  data.videoStartup.videoStartFailure.assetAvailability,
                        vsfRecalcEnable: data.videoStartup.videoStartFailure.recalcEnable,
                        vsfAlarmDuration: data.videoStartup.videoStartFailure.alarmDuration,

                        dnsTimingMaxTime: data.dns.timing.maxTime,
                        dnsTimingEnable: data.dns.timing.enable,
                        dnsTimingMaxErrors15Enable: data.dns.timing.maxErrors15.enable,
                        dnsTimingMaxErrors15Value: data.dns.timing.maxErrors15.value,

                        dnsErrorsMaxErrors15Enable: data.dns.errors.maxErrors15.enable,
                        dnsErrorsMaxErrors15Value: data.dns.errors.maxErrors15.value,
                        dnsErrorsWinSize: data.dns.errors.winSize,
                        dnsErrorsWinThresholdEnable: data.dns.errors.winThreshold.enable,
                        dnsErrorsWinThresholdValue: data.dns.errors.winThreshold.value,
                        dnsErrorsAvailabilty: data.dns.errors.assetAvailability,

                        tcpTimingMaxTime: data.tcp.timing.maxTime,
                        tcpTimingEnable: data.tcp.timing.enable,
                        tcpTimingMaxErrorsEnable: data.tcp.timing.maxErrors15.enable,
                        tcpTimingMaxErrorsValue: data.tcp.timing.maxErrors15.value,

                        tcpErrorsMaxErrors15Enable: data.tcp.errors.maxErrors15.enable,
                        tcpErrorsMaxErrors15Value: data.tcp.errors.maxErrors15.value,
                        tcpErrorsWinSize: data.tcp.errors.winSize,
                        tcpErrorsWinThresholdEnable: data.tcp.errors.winThreshold.enable,
                        tcpErrorsWinThresholdValue: data.tcp.errors.winThreshold.value,
                        tcpErrorsAvailability: data.tcp.errors.assetAvailability,

                        http4MaxEnable: data.http['4xx'].maxErrors15.enable,
                        http4MaxValue: data.http['4xx'].maxErrors15.value,
                        http4WinSize: data.http['4xx'].winSize,
                        http4WinThreshEnable: data.http['4xx'].winThreshold.enable,
                        http4WinThreshValue: data.http['4xx'].winThreshold.value,
                        http4Exclusions: data.http['4xx'].exclusions,

                        http5MaxEnable: data.http['5xx'].maxErrors15.enable,
                        http5MaxValue: data.http['5xx'].maxErrors15.value,
                        http5WinSize: data.http['5xx'].winSize,
                        http5WinThreshEnable: data.http['5xx'].winThreshold.enable,
                        http5WinThreshValue: data.http['5xx'].winThreshold.value,
                        http5Exclusions: data.http['5xx'].exclusions,

                        httpMimeEnable: data.http.mime.enable,
                        httpExpressions: data.http.mime.expressionList,

                        playlistStalledEnable: data.playlist.stalled.enable,
                        playlistStalledValue: data.playlist.stalled.time,
                        playlistStalledAvailability: data.playlist.stalled.assetAvailability,

                        playlistVariantErrorEnable: data.playlist.variantCount.errors15.enable,
                        playlistVariantErrorValue: data.playlist.variantCount.errors15.value,

                        playlistFileErrorEnable: data.playlist.fileErrors.errors15.enable,
                        playlistFileErrorValue: data.playlist.fileErrors.errors15.value,
                        playlistFileAvailability: data.playlist.fileErrors.assetAvailability,

                        playlistUnavailableErrorEnable: data.playlist.unavailable.maxErrors.enable,
                        playlistUnavailableErrorValue: data.playlist.unavailable.maxErrors.value,
                        playlistUnavailableAvailability: data.playlist.unavailable.assetAvailability,

                        playlistVariantsRequiredEnable: data.playlist.variantsRequired.enable,
                        playlistVariantsRequiredExpr: data.playlist.variantsRequired.expression,

                        mediaFilesSeqMaxEnable: data.mediaFiles.sequenceErrors.maxErrors.enable,
                        mediaFilesSeqMaxValue: data.mediaFiles.sequenceErrors.maxErrors.value,
                        mediaFilesSeqMax15Enable: data.mediaFiles.sequenceErrors.maxErrors15.enable,
                        mediaFilesSeqMax15Value: data.mediaFiles.sequenceErrors.maxErrors15.value,
                        mediaFilesSeqMaxContEnable: data.mediaFiles.sequenceErrors.maxContiguousErrors.enable,
                        mediaFilesSeqMaxContValue: data.mediaFiles.sequenceErrors.maxContiguousErrors.value,
                        mediaFilesSeqAvailability: data.mediaFiles.sequenceErrors.assetAvailability,
                        mediaFilesSeqESPeriod: data.mediaFiles.sequenceErrors.ESPeriod,

                        mediaFilesDurMax15Enable: data.mediaFiles.duration.maxErrors15.enable,
                        mediaFilesDurMax15Value: data.mediaFiles.duration.maxErrors15.value,
                        mediaFilesDurMax: data.mediaFiles.duration.maxDuration,
                        mediaFilesDurMaxAvailability: data.mediaFiles.duration.assetAvailability,
                        mediaFilesDurESPeriod: data.mediaFiles.duration.ESPeriod,

                        mediaFilesBRDeviation: data.mediaFiles.bitrate.deviation,
                        mediaFilesBR15Enable: data.mediaFiles.bitrate.maxErrors15.enable,
                        mediaFilesBR15Value: data.mediaFiles.bitrate.maxErrors15.value,

                        mediaFilesAudioEnable: data.mediaFiles.audioNotPresent.enable,
                        mediaFilesAudioAvailability: data.mediaFiles.audioNotPresent.assetAvailability,

                        mediaFilesVideoEnable: data.mediaFiles.videoAudioSync.threshold.enable,
                        mediaFilesVideoValue: data.mediaFiles.videoAudioSync.threshold.value,
                        mediaFilesVideoAvailability: data.mediaFiles.videoAudioSync.assetAvailability,

                        mediaFilesDecryptEnable: data.mediaFiles.decryptErrors.enable,
                        mediaFilesDecryptAvailability: data.mediaFiles.decryptErrors.assetAvailability,

                        mediaFilesOutAvailability: data.mediaFiles.outage.assetAvailability,
                        mediaFilesOutThreshold: data.mediaFiles.outage.threshold,

                        mediaFilesUnavailWinSize: data.mediaFiles.unavailable.winSize,
                        mediaFilesUnavailMaxEnable: data.mediaFiles.unavailable.maxErrors.enable,
                        mediaFilesUnavailMaxValue: data.mediaFiles.unavailable.maxErrors.value,
                        mediaFilesUnavailMaxAvailability: data.mediaFiles.unavailable.assetAvailability,

                        dlTimeMaxEnable: data.mediaFiles.downloadTime.maxErrors.enable,
                        dlTimeMaxValue: data.mediaFiles.downloadTime.maxErrors.value,
                        dlTimeDevValue: data.mediaFiles.downloadTime.deviation,
                        dlTimeWinSize: data.mediaFiles.downloadTime.winSize,

                        mediaTimeEnable: data.mediaFiles.mediaTime.enable,
                        mediaTimeDevMin: data.mediaFiles.mediaTime.mediaTimeDevMin,
                        mediaTimeDevMax: data.mediaFiles.mediaTime.mediaTimeDevMax,

                        veristreamThreshold: data.veristream.threshold,
                        veristreamMaxEP: data.veristream.maxErrorPeriod,
                        veristreamMaxED: data.veristream.maxErrorDistance,
                        veristreamMaxEPEnable: data.veristream.errorPeriod.enable,
                        veristreamMaxEP15Enable: data.veristream.errorPeriod.maxErrorPeriod15.enable,
                        veristreamMaxEP15Value: data.veristream.errorPeriod.maxErrorPeriod15.value,
                        veristreamMaxEDEnable: data.veristream.errorDistance.enable,
                        veristreamBufferThreshEnable: data.veristream.bufferGearChangeRisk.threshold.enable,
                        veristreamBufferThreshValue: data.veristream.bufferGearChangeRisk.threshold.value,
                        veristreamBufferMax15Enable: data.veristream.bufferGearChangeRisk.maxEvents15.enable,
                        veristreamBufferMax15Value: data.veristream.bufferGearChangeRisk.maxEvents15.value,
                        veristreamBufferWinSize: data.veristream.bufferGearChangeRisk.winSize,
                        veristreamBufferWinThreshEnable: data.veristream.bufferGearChangeRisk.winThreshold.enable,
                        veristreamBufferWinThreshValue: data.veristream.bufferGearChangeRisk.winThreshold.value,
                        veristreamBufferAvailability: data.veristream.bufferGearChangeRisk.assetAvailability,

                        subtitleCaptionThreshold: data.subtitle.captionCount.threshold,
                        subtitleCaptionWinSize: data.subtitle.captionCount.winSize,
                        subtitleCaptionWinMaxEnable: data.subtitle.captionCount.winMax.enable,
                        subtitleCaptionWinMaxValue: data.subtitle.captionCount.winMax.value,
                        subtitleFormatWinSize: data.subtitle.formatErrors.winSize,
                        subtitleFormatWinMaxEnable: data.subtitle.formatErrors.winMax.enable,
                        subtitleFormatWinMaxValue: data.subtitle.formatErrors.winMax.value,
                        subtitleStalledThreshEnable: data.subtitle.stalledText.threshold.enable,
                        subtitleStalledThreshValue: data.subtitle.stalledText.threshold.value,

                        mosAudioThreshEnable: data.qoe ? data.qoe.mosAudio.threshold.enable : '',
                        mosAudioThreshValue:  data.qoe ? data.qoe.mosAudio.threshold.value.toFixed(1) : '',
                        mosAudioDurError:  data.qoe ? data.qoe.mosAudio.durError : '',
                        mosAudioAvailEnable: data.qoe ? data.qoe.mosAudio.availDurError.enable : '',
                        mosAudioAvailDurError:  data.qoe ? data.qoe.mosAudio.availDurError.value : '',

                        audioLoudnessMinEnable: data.qoe ? data.qoe.loudness.minThreshold.enable : '',
                        audioLoudnessMinValue: data.qoe ? data.qoe.loudness.minThreshold.value : '',
                        audioLoudnessMinDuration: data.qoe ? data.qoe.loudness.minDuration : '',
                        audioLoudnessMaxEnable: data.qoe ? data.qoe.loudness.maxThreshold.enable : '',
                        audioLoudnessMaxValue: data.qoe ? data.qoe.loudness.maxThreshold.value : '',
                        audioLoudnessMaxDuration: data.qoe ? data.qoe.loudness.maxDuration : '',

                        dialnormDevEnable: data.qoe ? data.qoe.dialnormDev.dialnormDevErrThr.enable : '',
                        targetLoudnessValue: data.qoe ? data.qoe.dialnormDev.audioLdDnDevTargLoud : '',
                        dialnormDevValue: data.qoe ? data.qoe.dialnormDev.dialnormDevErrThr.value : '',
                        dialnormDevDuration: data.qoe ? data.qoe.dialnormDev.durError : '',
                        dialnormDevAvailEnable: data.qoe ? data.qoe.dialnormDev.availDurError.enable : '',
                        dialnormDevAvailValue: data.qoe ? data.qoe.dialnormDev.availDurError.value : '',

                        silenceAlarmEnable: data.qoe ? data.qoe.silence.enable : '',
                        silenceDetectMode: data.qoe ? data.qoe.silence.silenceDetMode : '',
                        silenceChannels: data.qoe ? __this.getSilenceChannels(data.qoe.silence.silenceChannels) : '',
                        silenceAlarmDuration: data.qoe ? data.qoe.silence.durError : '',

                        mosVideoThreshEnable:  data.qoe ? data.qoe.mosVideo.threshold.enable : '',
                        mosVideoThreshValue:  data.qoe ? data.qoe.mosVideo.threshold.value.toFixed(1) : '',
                        mosVideoDurError: data.qoe ?  data.qoe.mosVideo.durError : '',
                        mosVideoAvailEnable: data.qoe ? data.qoe.mosVideo.availDurError.enable : '',
                        mosVideoAvailDurError:  data.qoe ? data.qoe.mosVideo.availDurError.value : '',

                        gopMosVideoThreshEnable:  data.qoe ? data.qoe.gopMos.threshold.enable : '',
                        gopMosVideoThreshValue:  data.qoe ? data.qoe.gopMos.threshold.value.toFixed(1) : '',
                        gopMosVideoDurError:  data.qoe ? data.qoe.gopMos.durError : '',
                        gopMosVideoAvailEnable:  data.qoe ? data.qoe.gopMos.availDurError.enable : '',

                        blacknessThreshEnable:  data.qoe ? data.qoe.blackness.threshold.enable : '',
                        blacknessThreshValue:  data.qoe ? data.qoe.blackness.threshold.value : '',
                        blacknessDurError:  data.qoe ? data.qoe.blackness.durError : '',
                        blacknessAvailEnable: data.qoe ? data.qoe.blackness.availDurError.enable : '',
                        blacknessAvailDurError:  data.qoe ? data.qoe.blackness.availDurError.value : '',

                        stillnessThreshEnable:  data.qoe ? data.qoe.stillness.threshold.enable : '',
                        stillnessThreshValue:  data.qoe ? data.qoe.stillness.threshold.value : '',
                        stillnessDurError:  data.qoe ?  data.qoe.stillness.durError : '',
                        stillnessAvailEnable: data.qoe ? data.qoe.stillness.availDurError.enable : '',
                        stillnessAvailDurError:  data.qoe ? data.qoe.stillness.availDurError.value : '',

                        idrFrameStartEnable: data.qoe ? data.qoe.idrFrameStart.idrFrameStartErrThr.enable : '',
                        idrFrameStartValue: data.qoe ? data.qoe.idrFrameStart.idrFrameStartErrThr.value : '',
                        idrFrameStartWinSize: data.qoe ? data.qoe.idrFrameStart.idrFrameStartWinSize : '',

                        pixelAnalysisThresholdValue: data.qoe ? data.qoe.pixelAnalysis.threshold.value : '',
                        pixelAnalysisThresholdEnable: data.qoe ? data.qoe.pixelAnalysis.threshold.enable : '',
                        pixelAnalysisDurationError: data.qoe ? data.qoe.pixelAnalysis.durError : '',

                        spliceAlarmEnable: data.dai ? data.dai.spliceAlarm.enable : '',
                        schedules: data.dai ? data.dai.spliceAlarm.schedule : '',
                        spliceSeqAlarmEnable: data.dai ? data.dai.spliceSeqAlarm.enable : '',
                        spliceSeqAlarmDurError: data.dai ? data.dai.spliceSeqAlarm.durError : '',
                        spliceSeqAlarmInNoOutMode: data.dai ? data.dai.spliceSeqAlarm.inNoOutMode : '',
                        spliceSeqAlarmOutNoInMode: data.dai ? data.dai.spliceSeqAlarm.outNoInMode : '',
                        spliceOutDur: data.dai ? data.dai.playbackDuration.spliceOutDur : '',
                        underThresholdEnable: data.dai ? data.dai.playbackDuration.pbUnderThreshold.enable : '',
                        underThresholdValue: data.dai ? data.dai.playbackDuration.pbUnderThreshold.value : '',
                        underDuration: data.dai ? data.dai.playbackDuration.underDuration : '',
                        overThresholdEnable: data.dai ? data.dai.playbackDuration.pbOverThreshold.enable : '',
                        overThresholdValue: data.dai ? data.dai.playbackDuration.pbOverThreshold.value : '',
                        overDuration: data.dai ? data.dai.playbackDuration.overDuration : '',
                        formatMismatchEnable: data.dai ? data.dai.formatMismatch.enable : '',
                        formatDurError: data.dai ? data.dai.formatMismatch.durError : '',
                        manifestMode: data.dai ? data.dai.formatMismatch.manifestMode : '',
                        fileMode: data.dai ? data.dai.formatMismatch.fileMode : '',
                        videoCodecChar: data.dai ? data.dai.formatMismatch.videoCodecChar : '',
                        videoResChar: data.dai ? data.dai.formatMismatch.videoResChar : '',
                        audioSampChar: data.dai ? data.dai.formatMismatch.audioSampChar : '',
                        mfDurMinEnable: data.dai ? data.dai.playbackDuration.mfDurMinThreshold.enable : '',
                        mfDurMinValue: data.dai ? data.dai.playbackDuration.mfDurMinThreshold.value : '',
                        mfDurMinDuration: data.dai ? data.dai.playbackDuration.mfDurMinDuration : '',
                        mfTimingAlignEnable: data.mediaFiles ? data.mediaFiles.mfTimingAlign.enable : '',
                        mfTimingAlignDur: data.mediaFiles ? data.mediaFiles.mfTimingAlign.durError : '',
                        mfTimingAlignMode : data.mediaFiles ? data.mediaFiles.mfTimingAlign.mode : '',
                        mfTimingAlignVideo : data.mediaFiles ? data.mediaFiles.mfTimingAlign.videoType : '',
                        mfTimingAlignAudio : data.mediaFiles ? data.mediaFiles.mfTimingAlign.audioType : '',
                        mfTimingAlignTol : data.mediaFiles ? data.mediaFiles.mfTimingAlign.tolerance : '',

                        audioSilenceError:  data.thumbnails ? data.thumbnails.archiveConditions.audioSilenceError : '',
                        blacknessErrors:  data.thumbnails ? data.thumbnails.archiveConditions.blacknessErrors : '',
                        dialNormDevError:  data.thumbnails ?  data.thumbnails.archiveConditions.dialNormDevError : '',
                        maxAudioLoudnessErrors: data.thumbnails ? data.thumbnails.archiveConditions.maxAudioLoudnessErrors : '',
                        minAudioLoudnessErrors:  data.thumbnails ? data.thumbnails.archiveConditions.minAudioLoudnessErrors : '',
                        mosAudioError:  data.thumbnails ? data.thumbnails.archiveConditions.mosAudioError : '',
                        mosVideoErrors:  data.thumbnails ? data.thumbnails.archiveConditions.mosVideoErrors : '',
                        stillnessErrors:  data.thumbnails ?  data.thumbnails.archiveConditions.stillnessErrors : '',
                        pixelAnalysisVODThumbnailArchive:  data.thumbnails ?  data.thumbnails.archiveConditions.pixelError : '',
                        mosGopError: data.thumbnails ? data.thumbnails.archiveConditions.mosGopError : ''
                    });
                    __this.extractVariantsRequired();
                }
            }).catch(function (error: AxiosRequestConfig) {
            // tslint:disable-next-line:no-console
            console.log('fetchData() error: ', error);
        });
    }

    validateQoE() {
        let _this = this;
        let message = '';
        // console.log('*** Validate QoE! ***');
        // check ranges on thresholds
        if (!(this.state.mosVideoThreshValue >= 1) || !(this.state.mosVideoThreshValue <= 5)) {
            message = 'Video MOS threshold is out of range (1 - 5). Please correct to continue.';
        } else if (this.state.mosVideoDurError < 0) {
            message = 'Video MOS alarm duration is out of range (> 0). Please correct to continue.';
        } else if (this.state.mosVideoAvailDurError < 0) {
            message = 'Video MOS Availability duration is out of range (> 0). Please correct to continue.';
        } else if (!(this.state.blacknessThreshValue >= 10) || !(this.state.blacknessThreshValue <= 100)) {
            message = 'Black Screen percentage is out of range (10 - 100). Please correct to continue.';
        } else if (this.state.blacknessDurError < 0) {
            message = 'Black Screen alarm duration is out of range (> 0). Please correct to continue.';
        } else if (this.state.blacknessAvailDurError < 0) {
            message = 'Black Screen Availability duration is out of range (> 0). Please correct to continue.';
        } else if (!(this.state.stillnessThreshValue >= 0) || !(this.state.stillnessThreshValue <= 50)) {
            message = 'Still Frame percentage is out of range (0 - 50). Please correct to continue.';
        } else if (this.state.stillnessDurError < 0) {
            message = 'Still Frame alarm duration is out of range (> 0). Please correct to continue.';
        } else if (this.state.stillnessAvailDurError < 0) {
            message = 'Still Frame Availability duration is out of range (> 0). Please correct to continue.';
        } else if (!(this.state.mosAudioThreshValue >= 1) || !(this.state.mosAudioThreshValue <= 5)) {
            message = 'Audio MOS threshold is out of range (1 - 5). Please correct to continue.';
        } else if (this.state.mosAudioDurError < 0) {
            message = 'Audio MOS alarm duration is out of range (> 0). Please correct to continue.';
        } else if (this.state.mosAudioAvailDurError < 0) {
            message = 'Audio MOS Availability duration is out of range (> 0). Please correct to continue.';
        } else if (!(this.state.audioLoudnessMinValue >= -100) || !(this.state.audioLoudnessMinValue <= 20)) {
            message = 'Loudness Min threshold is out of range (-100 - 20). Please correct to continue.';
        } else if (this.state.audioLoudnessMinDuration < 0) {
            message = 'Loudness Min alarm duration is out of range (> 0). Please correct to continue.';
        } else if (!(this.state.audioLoudnessMaxValue >= -100) || !(this.state.audioLoudnessMaxValue <= 20)) {
            message = 'Loudness Max threshold is out of range (-100 - 20). Please correct to continue.';
        } else if (this.state.audioLoudnessMaxDuration < 0) {
            message = 'Loudness Max alarm duration is out of range (> 0). Please correct to continue.';
        } else if (!(this.state.targetLoudnessValue >= -100) || !(this.state.targetLoudnessValue <= 20)) {
            message = 'Loudness-Dialnorm Deviation Target Loudness value is out of range (-100 - 20). Please correct to continue.';
        } else if (!(this.state.dialnormDevValue >= 0) || !(this.state.dialnormDevValue <= 100)) {
            message = 'Loudness-Dialnorm Deviation Maximum Deviation value is out of range (0 - 100). Please correct to continue.';
        } else if (this.state.dialnormDevDuration < 0) {
            message = 'Loudness-Dialnorm Deviation Maximum Deviation alarm duration is out of range (> 0). Please correct to continue.';
        } else if (this.state.dialnormDevAvailValue < 0) {
            message = 'Loudness-Dialnorm Deviation Availability duration is out of range (> 0). Please correct to continue.';
        } else if (this.state.silenceAlarmDuration < 0) {
            message = 'Silence alarm duration is out of range (> 0). Please correct to continue.';
        }

        if (!(message === '')) {
            _this.setState({
                showErrorModal: true,
                errorMessage: message
            });
        } else {
            this.transformVariants();
        }
    }

    compareFunction(a: any, b: any) {
        // Sort schedule in increasing order of start time
        if (a.start > b.start)
            return 1;
        else
            return -1;
    }

    isOverlap() {
        let schedules = [...this.state.schedules];
        schedules.sort(this.compareFunction);
        // In the sorted array, if start time of a schedule
        // is less than end of previous schedule, then there
        // is an overlap
        for (let i = 1; i < Object.keys(this.state.schedules).length; i++) {
            if (schedules[i - 1].end > schedules[i].start) {
                return true;
            }
        }
        // If we reach here, then no overlap
        return false;
    }

    validDAISchedules() {
        let _this = this;
        let message = '';
        let threshold = 0;

        // check if schedule overlap
        if (this.isOverlap()) {
            message = 'Invalid Splice Events Schedule. Schedules overlap.';
        } else {
            // check that the array values make sense before sending to API.
            for (let i = 0; i < Object.keys(this.state.schedules).length; i++) {
                if (this.state.schedules[i].start === this.state.schedules[i].end) {
                    message = 'Invalid Splice Events Schedule. Start Time = End Time';
                } else if (this.state.schedules[i].start > this.state.schedules[i].end) {
                    message = 'Invalid Splice Events Schedule. Start Time > End Time';
                } else if (this.state.schedules[i].threshold <= 0 || this.state.schedules[i].threshold > 9999) {
                    message = 'Invalid Splice Events Schedule Threshold. Range 1 - 9999';
                } else {
                    threshold = (this.state.schedules[i].end - this.state.schedules[i].start) * 60;
                    if (!(this.state.schedules[i].threshold <= threshold)) {
                        message = 'Invalid Splice Events Schedule Threshold. Lower schedule threshold.';
                    }
                    this.state.schedules[i].threshold = parseInt(this.state.schedules[i].threshold, 10);
                }
            }
        }

        if (!(message === '')) {
            _this.setState({
            showErrorModal: true,
            errorMessage: message
            });
            return false;
        } else {
            return true;
        }
    }

    validateVariants(expression: any) {
        let _this = this;
        // console.log('***validate: ' + expression);
        if (this.state.playlistVariantsRequiredEnable && expression === '') {
            _this.setState({showValidateModal: true});
            this.update();
        } else {
            axios.post('http://default/api/stream/validate/required-variants', {
                'input': expression
            })
                .then(function (response: AxiosResponse) {
                    if (response.data.parseErrors === 0) {
                        _this.extractVariantsRequired();
                        _this.update();
                    } else throw response;
                }).catch(error => {
                _this.setState({showValidateModal: true});
            });
        }
    }

    testValidateVariants() {
        let _this = this;
        if (this.state.playlistVariantsRequiredExpr && this.state.playlistVariantsRequiredExpr !== '') {
            axios.post('http://default/api/stream/validate/required-variants', {
                'input': this.state.playlistVariantsRequiredExpr
            })
                .then(function (response: AxiosResponse) {
                    if (response.data.parseErrors === 0) {
                        // tslint:disable-next-line:no-console
                        console.log('No Errors validating required variants.');
                    } else throw response;
                }).catch(error => {
                _this.setState({showValidateModal: true});
            });
        }
    }

    updateConfig(e: any, data: any) {
        if ((this.state.templateName !== this.props.templateName) && (this.props.allTemplates.includes(this.state.templateName))) {
            this.setState({showModal: true});
        } else {
            this.update();
        }
    }

    update() {
        // console.log('*** Update Configuration ***');
        if (this.state.DAILicensePresent) {
            if (!this.validDAISchedules()) {
                return;
            }
        }

        this.setSilenceChannels();
        this.handleWarningClose();
        // tslint:disable-next-line:variable-name
        let __this = this;
        let mode = 'all segments';
        let url = 'http://default/api/config/templates/adp/alarm/' + encodeURIComponent(this.state.templateName);
        let operation = 'update';
        if (this.state.templateName === 'streamDefault') {
            mode = 'any';
        } else {
            if (this.props.mode === 'All Segments') {
                mode = 'all segments';
            } else if (this.props.mode === 'Sample') {
                mode = 'sample';
            } else if (this.props.mode === 'Header Only') {
                mode = 'header only';
            } else if (this.props.mode === 'VOD') {
                mode = 'vod';
            } else if (this.props.mode === 'Dynamic Ad') {
                mode = 'dynamic ad';
            }
        }
        if (this.props.templateName === 'Add New Template') {
            operation = 'add';
        }
        let dataObj = {
            'name': (this.props.templateName === 'streamDefault' ? this.props.templateName : this.state.templateName),
            'mode': mode,
            'videoStartup': {
                'mediaReceiveDuration': {
                    'mode': this.state.mediaReceiveDurationMode,
                    'file': parseInt(this.state.mediaReceiveDurationFile, 10),
                    'time': parseInt(this.state.mediaReceiveDurationTime, 10)
                },
                'derivedVariantStartupTime': {
                    'enable': this.state.derivedVariantStartupTimeEnable,
                    'errorThreshold': parseInt(this.state.derivedVariantStartupTimeThreshold, 10),
                    'recalcEnable': this.state.dvstRecalcEnable,
                    'alarmDuration': this.state.dvstAlarmDuration,
                },
                'videoStartFailure': {
                    'enable': this.state.videoStartFailureEnable,
                    'threshold': parseInt(this.state.videoStartFailureThreshold, 10),
                    'assetAvailability': this.state.videoStartFailureAvailability,
                    'recalcEnable': this.state.vsfRecalcEnable,
                    'alarmDuration': this.state.vsfAlarmDuration,
                }
            },
            'dns': {
                'timing': {
                    'enable': this.state.dnsTimingEnable, 'maxTime': parseInt(this.state.dnsTimingMaxTime, 10),
                    'maxErrors15': {
                        'enable': this.state.dnsTimingMaxErrors15Enable, 'value': parseInt(this.state.dnsTimingMaxErrors15Value, 10)
                    }
                },
                'errors': {
                    'maxErrors15': {
                        'enable': this.state.dnsErrorsMaxErrors15Enable, 'value': parseInt(this.state.dnsErrorsMaxErrors15Value, 10)
                    },
                    'winSize': parseInt(this.state.dnsErrorsWinSize, 10),
                    'winThreshold': {
                        'enable': this.state.dnsErrorsWinThresholdEnable, 'value': parseInt(this.state.dnsErrorsWinThresholdValue, 10)
                    },
                    'assetAvailability': this.state.dnsErrorsAvailabilty
                }
            },
            'tcp': {
                'timing': {
                    'enable': this.state.tcpTimingEnable, 'maxTime': parseInt(this.state.tcpTimingMaxTime, 10),
                    'maxErrors15': {
                        'enable': this.state.tcpTimingMaxErrorsEnable, 'value': parseInt(this.state.tcpTimingMaxErrorsValue, 10)
                    }
                },
                'errors': {
                    'maxErrors15': {
                        'enable': this.state.tcpErrorsMaxErrors15Enable, 'value': parseInt(this.state.tcpErrorsMaxErrors15Value, 10)
                    },
                    'winSize': parseInt(this.state.tcpErrorsWinSize, 10),
                    'winThreshold': {
                        'enable': this.state.tcpErrorsWinThresholdEnable, 'value': parseInt(this.state.tcpErrorsWinThresholdValue, 10)
                    },
                    'assetAvailability': this.state.tcpErrorsAvailability
                }
            },
            'http': {
                '4xx': {
                    'maxErrors15': {
                        'enable': this.state.http4MaxEnable, 'value': parseInt(this.state.http4MaxValue, 10)
                    },
                    'winSize': parseInt(this.state.http4WinSize, 10),
                    'winThreshold': {
                        'enable': this.state.http4WinThreshEnable, 'value': parseInt(this.state.http4WinThreshValue, 10)
                    },
                    'exclusions': this.state.http4Exclusions
                },
                '5xx': {
                    'maxErrors15': {
                        'enable': this.state.http5MaxEnable, 'value': parseInt(this.state.http5MaxValue, 10)
                    },
                    'winSize': parseInt(this.state.http5WinSize, 10),
                    'winThreshold': {
                        'enable': this.state.http5WinThreshEnable, 'value': parseInt(this.state.http5WinThreshValue, 10)
                    },
                    'exclusions': this.state.http5Exclusions
                },
                'mime': {
                    'enable': this.state.httpMimeEnable, 'expressionList': this.state.httpExpressions
                }
            },
            'playlist': {
                'stalled': {
                    'enable': this.state.playlistStalledEnable,
                    'time': parseInt(this.state.playlistStalledValue, 10),
                    'assetAvailability': this.state.playlistStalledAvailability
                },
                'variantCount': {
                    'errors15': {
                        'enable': this.state.playlistVariantErrorEnable, 'value': parseInt(this.state.playlistVariantErrorValue, 10)
                    }
                },
                'fileErrors': {
                    'errors15': {
                        'enable': this.state.playlistFileErrorEnable, 'value': parseInt(this.state.playlistFileErrorValue, 10)
                    },
                    'assetAvailability': this.state.playlistFileAvailability
                },
                'unavailable': {
                    'maxErrors': {
                        'enable': this.state.playlistUnavailableErrorEnable, 'value': parseInt(this.state.playlistUnavailableErrorValue, 10)
                    },
                    'assetAvailability': this.state.playlistUnavailableAvailability
                },
                'variantsRequired': {
                    'enable': this.state.playlistVariantsRequiredEnable, 'expression': this.state.playlistVariantsRequiredExpr
                }
            },
            'mediaFiles': {
                'sequenceErrors': {
                    'maxErrors': {
                        'enable': this.state.mediaFilesSeqMaxEnable, 'value': parseInt(this.state.mediaFilesSeqMaxValue, 10)
                    },
                    'maxErrors15': {
                        'enable': this.state.mediaFilesSeqMax15Enable, 'value': parseInt(this.state.mediaFilesSeqMax15Value, 10)
                    },
                    'maxContiguousErrors': {
                        'enable': this.state.mediaFilesSeqMaxContEnable, 'value': parseInt(this.state.mediaFilesSeqMaxContValue, 10)
                    },
                    'assetAvailability': this.state.mediaFilesSeqAvailability, 'ESPeriod': parseInt(this.state.mediaFilesSeqESPeriod, 10)
                },
                'duration': {
                    'maxDuration': parseInt(this.state.mediaFilesDurMax, 10),
                    'maxErrors15': {
                        'enable': this.state.mediaFilesDurMax15Enable, 'value': parseInt(this.state.mediaFilesDurMax15Value, 10)
                    },
                    'assetAvailability': this.state.mediaFilesDurMaxAvailability,
                    'ESPeriod': parseInt(this.state.mediaFilesDurESPeriod, 10)
                },
                'bitrate': {
                    'deviation': parseInt(this.state.mediaFilesBRDeviation, 10),
                    'maxErrors15': {
                        'enable': this.state.mediaFilesBR15Enable, 'value': parseInt(this.state.mediaFilesBR15Value, 10)
                    }
                },
                'audioNotPresent': {
                    'enable': this.state.mediaFilesAudioEnable, 'assetAvailability': this.state.mediaFilesAudioAvailability
                },
                'videoAudioSync': {
                    'threshold': {
                        'enable': this.state.mediaFilesVideoEnable, 'value': parseInt(this.state.mediaFilesVideoValue, 10)
                    },
                    'assetAvailability': this.state.mediaFilesVideoAvailability
                },
                'decryptErrors': {
                    'enable': this.state.mediaFilesDecryptEnable,
                    'assetAvailability': this.state.mediaFilesDecryptAvailability
                },
                'outage': {
                    'threshold': parseInt(this.state.mediaFilesOutThreshold, 10), 'assetAvailability': this.state.mediaFilesOutAvailability
                },
                'unavailable': {
                    'winSize': parseInt(this.state.mediaFilesUnavailWinSize, 10),
                    'maxErrors': {
                        'enable': this.state.mediaFilesUnavailMaxEnable, 'value': parseInt(this.state.mediaFilesUnavailMaxValue, 10)
                    },
                    'assetAvailability': this.state.mediaFilesUnavailMaxAvailability
                },
                'downloadTime': {
                    'maxErrors': {
                        'enable': this.state.dlTimeMaxEnable, 'value': parseInt(this.state.dlTimeMaxValue, 10)
                    },
                    'deviation': parseInt(this.state.dlTimeDevValue, 10),
                    'winSize': parseInt(this.state.dlTimeWinSize, 10)
                },
                'mediaTime': {
                    'enable': this.state.mediaTimeEnable,
                    'mediaTimeDevMin': this.state.mediaTimeDevMin,
                    'mediaTimeDevMax': this.state.mediaTimeDevMax
                },
                'mfTimingAlign': {
                    'enable': this.state.mfTimingAlignEnable,
                    'durError': this.state.mfTimingAlignDur,
                    'mode': this.state.mfTimingAlignMode,
                    'videoType': this.state.mfTimingAlignVideo,
                    'audioType': this.state.mfTimingAlignAudio,
                    'tolerance': this.state.mfTimingAlignTol
                }
            },
            'veristream': {
                'threshold': parseInt(this.state.veristreamThreshold, 10), 'maxErrorPeriod': parseInt(this.state.veristreamMaxEP, 10),
                'maxErrorDistance': parseInt(this.state.veristreamMaxED, 10),
                'errorPeriod': {
                    'enable': this.state.veristreamMaxEPEnable,
                    'maxErrorPeriod15': {
                        'enable': this.state.veristreamMaxEP15Enable, 'value': parseInt(this.state.veristreamMaxEP15Value, 10)
                    }
                },
                'errorDistance': {
                    'enable': this.state.veristreamMaxEDEnable
                },
                'bufferGearChangeRisk': {
                    'threshold': {
                        'enable': this.state.veristreamBufferThreshEnable, 'value': parseInt(this.state.veristreamBufferThreshValue, 10)
                    },
                    'maxEvents15': {
                        'enable': this.state.veristreamBufferMax15Enable, 'value': parseInt(this.state.veristreamBufferMax15Value, 10)
                    },
                    'winSize': parseInt(this.state.veristreamBufferWinSize, 10),
                    'winThreshold': {
                        'enable': this.state.veristreamBufferWinThreshEnable, 'value': parseInt(this.state.veristreamBufferWinThreshValue, 10)
                    },
                    'assetAvailability': this.state.veristreamBufferAvailability
                }
            },
            'subtitle': {
                'captionCount': {
                    'threshold': parseInt(this.state.subtitleCaptionThreshold, 10),
                    'winSize': parseInt(this.state.subtitleCaptionWinSize, 10),
                    'winMax': {
                        'enable': this.state.subtitleCaptionWinMaxEnable, 'value': parseInt(this.state.subtitleCaptionWinMaxValue, 10)
                    }
                },
                'formatErrors': {
                    'winSize': parseInt(this.state.subtitleFormatWinSize, 10),
                    'winMax': {
                        'enable': this.state.subtitleFormatWinMaxEnable,
                        'value': parseInt(this.state.subtitleFormatWinMaxValue, 10)
                    }
                },
                'stalledText': {
                    'threshold': {
                        'enable': this.state.subtitleStalledThreshEnable,
                        'value': parseInt(this.state.subtitleStalledThreshValue, 10)
                    }
                }
            },
            'qoe': {
                'mosVideo': {
                    'threshold': {
                        'enable': this.state.mosVideoThreshEnable,
                        'value': parseFloat(Number(this.state.mosVideoThreshValue).toFixed(1))
                    },
                    'durError': parseInt(this.state.mosVideoDurError, 10),
                    'availDurError': {
                        'enable': this.state.mosVideoAvailEnable,
                        'value': parseInt(this.state.mosVideoAvailDurError, 10)
                    }
                },
                'gopMos': {
                    'threshold': {
                        'enable': this.state.gopMosVideoThreshEnable,
                        'value': parseFloat(Number(this.state.gopMosVideoThreshValue).toFixed(1))
                    },
                    'durError': parseInt(this.state.gopMosVideoDurError, 10),
                    'availDurError': {
                        'enable': this.state.gopMosVideoAvailEnable
                    }
                },
                'mosAudio': {
                    'threshold': {
                        'enable': this.state.mosAudioThreshEnable,
                        'value': parseFloat(Number(this.state.mosAudioThreshValue).toFixed(1))
                    },
                    'durError': parseInt(this.state.mosAudioDurError, 10),
                    'availDurError': {
                        'enable': this.state.mosAudioAvailEnable,
                        'value': parseInt(this.state.mosAudioAvailDurError, 10)
                    }
                },
                'loudness': {
                    'maxDuration': parseInt(this.state.audioLoudnessMaxDuration, 10),
                    'maxThreshold': {
                        'enable': this.state.audioLoudnessMaxEnable,
                        'value': parseInt(this.state.audioLoudnessMaxValue, 10)
                    },
                    'minDuration': parseInt(this.state.audioLoudnessMinDuration, 10),
                    'minThreshold': {
                        'enable': this.state.audioLoudnessMinEnable,
                        'value': parseInt(this.state.audioLoudnessMinValue, 10)
                    }
                },
                'dialnormDev': {
                    'audioLdDnDevTargLoud': parseInt(this.state.targetLoudnessValue, 10),
                    'availDurError': {
                        'enable': this.state.dialnormDevAvailEnable,
                        'value': parseInt(this.state.dialnormDevAvailValue, 10)
                    },
                    'dialnormDevErrThr': {
                        'enable': this.state.dialnormDevEnable,
                        'value': parseInt(this.state.dialnormDevValue, 10)
                    },
                    'durError': parseInt(this.state.dialnormDevDuration, 10),
                },
                'silence': {
                    'durError': parseInt(this.state.silenceAlarmDuration, 10),
                    'enable': this.state.silenceAlarmEnable,
                    'silenceChannels': parseInt(this.state.silenceChannels, 10),
                    'silenceDetMode': parseInt(this.state.silenceDetectMode, 10)
                },
                'blackness': {
                    'threshold': {
                        'enable': this.state.blacknessThreshEnable,
                        'value': parseInt(this.state.blacknessThreshValue, 10)
                    },
                    'durError': parseInt(this.state.blacknessDurError, 10),
                    'availDurError': {
                        'enable': this.state.blacknessAvailEnable,
                        'value': parseInt(this.state.blacknessAvailDurError, 10)
                    }
                },
                'stillness': {
                    'threshold': {
                        'enable': this.state.stillnessThreshEnable,
                        'value': parseInt(this.state.stillnessThreshValue, 10)
                    },
                    'durError': parseInt(this.state.stillnessDurError, 10),
                    'availDurError': {
                        'enable': this.state.stillnessAvailEnable,
                        'value': parseInt(this.state.stillnessAvailDurError, 10)
                    }
                },
                'idrFrameStart': {
                    'idrFrameStartErrThr': {
                        'enable': this.state.idrFrameStartEnable,
                        'value': this.state.idrFrameStartValue
                    },
                    'idrFrameStartWinSize': this.state.idrFrameStartWinSize
                },
                'pixelAnalysis': {
                    'threshold': {
                        'enable': this.state.pixelAnalysisThresholdEnable,
                        'value': this.state.pixelAnalysisThresholdValue
                    },
                    'durError': this.state.pixelAnalysisDurationError
                }
            },
            'dai': {
                'spliceAlarm': {
                    'enable': this.state.spliceAlarmEnable,
                    'schedule': this.state.schedules
                },
                'spliceSeqAlarm': {
                    'enable': this.state.spliceSeqAlarmEnable,
                    'durError': this.state.spliceSeqAlarmDurError,
                    'inNoOutMode': this.state.spliceSeqAlarmInNoOutMode,
                    'outNoInMode': this.state.spliceSeqAlarmOutNoInMode
                },
                'playbackDuration': {
                    'spliceOutDur': this.state.spliceOutDur,
                    'pbUnderThreshold': {
                        'enable': this.state.underThresholdEnable,
                        'value': this.state.underThresholdValue
                    },
                    'underDuration': this.state.underDuration,
                    'pbOverThreshold': {
                        'enable': this.state.overThresholdEnable,
                        'value': this.state.overThresholdValue
                    },
                    'overDuration': this.state.overDuration,
                    'mfDurMinThreshold': {
                        'enable': this.state.mfDurMinEnable,
                        'value': this.state.mfDurMinValue
                    },
                    'mfDurMinDuration': this.state.mfDurMinDuration,
                },
                'formatMismatch': {
                    'enable': this.state.formatMismatchEnable,
                    'durError': this.state.formatDurError,
                    'manifestMode': this.state.manifestMode,
                    'fileMode': this.state.fileMode,
                    'videoCodecChar': this.state.videoCodecChar,
                    'videoResChar': this.state.videoResChar,
                    'audioSampChar': this.state.audioSampChar
                }
            },
            'thumbnails': {
                'archiveConditions': {
                    'audioSilenceError': this.state.audioSilenceError,
                    'blacknessErrors': this.state.blacknessErrors,
                    'dialNormDevError': this.state.dialNormDevError,
                    'maxAudioLoudnessErrors': this.state.maxAudioLoudnessErrors,
                    'minAudioLoudnessErrors': this.state.minAudioLoudnessErrors,
                    'mosAudioError': this.state.mosAudioError,
                    'mosVideoErrors': this.state.mosVideoErrors,
                    'stillnessErrors': this.state.stillnessErrors,
                    'pixelError': this.state.pixelAnalysisVODThumbnailArchive,
                    'mosGopError': this.state.mosGopError
                }
            }
        };

        axios.post(url, dataObj
        )
            .then( (response: AxiosResponse) => {
                if (response.data.code === 'SUCCESS') {
                    __this.props.refresh(operation, mode, __this.state.templateName);
                    Toast.info(this.state.templateName + ' template updated');
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('request error: ', response.data);
                    Toast.error('Failed to update ' + this.state.templateName + ' template');
                }
            }).catch( (error: AxiosRequestConfig) => {
            // tslint:disable-next-line:no-console
            console.log('fetchData() error: ', error);
            Toast.error('Failed to update ' + this.state.templateName + ' template');
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/alarmTemplate/alarmTemplateConfig.tsx